import React from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import styled from 'styled-components'
import { grid } from 'styled-components-grid'
import GridUnit from 'styled-components-grid/dist/cjs/components/GridUnit'
import BlogBanner from '../../components/blocks/BlogBanner'
import LegalPage from '../../components/blocks/LegalPage'
import Layout from '../../components/layouts/layout'

const Container = styled.div`
  ${grid({})};
  padding: 0 60px;
  margin-top: 40px;
  margin-bottom: 103px;
  position: relative;
  overflow: hidden;
`

const TextContainer = styled(Container)`
  flex-direction: column;
  h4 {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 4.2px;
    line-height: 1.5;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  h2 {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 7.2px;
    line-height: 2;
    margin: 30px 0 40px 0;
  }
  h3 {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 7.2px;
    line-height: 1.7;
    margin: 20px 0 20px 0;
  }
  p {
    font-size: 13px;
    font-weight: 400;
    color: #a8a8a8;
    line-height: 1.661;
    letter-spacing: 0.26px;
    margin-bottom: 1rem;
  }
  img {
    max-width: 300px;
  }
  strong {
    font-weight: 700;
    color: #000000ad;
  }
`

const LegalPageTemplate = props => (
  <>
    <Helmet
      title='amber living - Stil & Eleganz für dein Zuhause | nutzungsbedingungen und datenschutz'
      meta={[
        {
          name: 'robots',
          content: props.pageContext.data?.index
            ? props.pageContext.data?.index
            : 'noindex, follow'
        }
      ]}
    />
    <Layout {...props} navigation={props.pageContext.navigation}>
      <LegalPage>
        <Container>
          <GridUnit size={{ xs: 1, sm: 7 / 16 }}>
            <BlogBanner.Box>
              <BlogBanner.BoxText>
                Nutzungsbedingungen & Datenschutz
              </BlogBanner.BoxText>
              <BlogBanner.BoxBottomText>AMBER LIVING</BlogBanner.BoxBottomText>
            </BlogBanner.Box>
          </GridUnit>
          <GridUnit size={{ sm: 1 / 16 }} />
          <GridUnit size={{ xs: 1, sm: 7 / 16 }} />
          <BlogBanner.FakeDiv />
        </Container>
        <TextContainer>
          <h4>Produktsuche</h4>
          <p>
            Media Juice bietet den Nutzern dieser Seite kostenlose
            Produktpräsentationen zu verschiedenen Themen bzw. eine kostenlose
            Suchfunktionen, um von angeschlossenen Shops Produkte zu finden.
            Media Juice selbst ist kein Händler oder Verkäufer von Waren. Auf
            dieser Seite bereitgestellte Produktinformation stellen kein Angebot
            von Media Juice dar. Durch die Nutzung des Angebotes werden
            keinerlei vertragliche Bindungen bezüglich der dargestellten
            Produkte mit Media Juice begründet. Insbesondere werden keine
            Kaufverträge mit Media Juice geschlossen. Media Juice leitet den
            Nutzer auf eine Angebotsseite eines Händlers weiter. Es obliegt dem
            Nutzer, die für einen Vertragsschluss maßgeblichen Informationen
            sowie Aktualität beim entsprechenden Händler selbst zu prüfen.
          </p>
          <h4>Suchergebnisse und Produktinformation</h4>
          <p>
            Die Inhalte sowie Anordnung der Suchergebnisse der Suchdienste
            werden durch automatisierte Verfahren erfasst und zusammengestellt.
            Media Juice ist bemüht diese Informationen möglichst aktuell zu
            halten. Aus technischen Gründen ist eine Aktualisierung in Echtzeit
            jedoch nicht möglich. Preise, Versandkosten und/oder
            Angebotsinformationen können deshalb abweichen und sich ggf. erhöht
            haben. Die Festlegung der Sortierreihenfolge liegt ausschließlich im
            Ermessen von Media Juice. Die Sortierung der Ergebnisse erfolgt nach
            unterschiedlichen Sortier- und Qualitätsfaktoren und kann ggf. durch
            von Händler gezahlten Provisionen beeinflusst werden. Media Juice
            übernimmt keine Haftung oder Garantie für die Qualität und
            Richtigkeit der Sortierung von Suchergebnissen. Die auf Media Juice
            in den Suchergebnissen bereitgestellten Inhalte und Preise werden
            durch Dritte bereitgestellt. Media Juice hat keinerlei Einfluss auf
            diese Inhalte und prüft diese nicht. Media Juice übernimmt daher
            keinerlei Gewähr oder Haftung, Garantie oder sonstige Verantwortung
            für die Richtigkeit, Vollständigkeit, Aktualität oder sonstige
            Eigenschaften dieser Inhalte. Insbesondere wird keine Gewähr dafür
            übernommen, dass die in der Suche dargestellten Produkte zu den
            genannten Bedingungen tatsächlich erworben werden können.
            Haftungsansprüche gegen Media Juice, welche sich auf Schäden
            materieller oder ideeller Art beziehen, die durch die Nutzung oder
            Nichtnutzung der bereitgestellten Informationen bzw. durch die
            Nutzung fehlerhafter und unvollständiger Informationen verursacht
            wurden, sind grundsätzlich ausgeschlossen, sofern nicht ein
            vorsätzliches oder grob fahrlässiges Verschulden von Media Juice
            vorliegt. Alle innerhalb des Internetangebotes genannten und ggf.
            durch Dritte geschützten Marken- und Warenzeichen unterliegen
            uneingeschränkt den Bestimmungen des jeweils gültigen
            Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen
            Eigentümer.
          </p>
          <h4>Nutzungsrechte</h4>
          <p>
            Die auf Media Juice bekanntgemachten Informationen und Angebote
            dienen ausschließlich der persönlichen Information. Eine
            (elektronische) Speicherung oder Weiterverarbeitung dieser Inhalte
            ist nicht gestattet. Insbesondere ist es auch nicht gestattet,
            automatisierte Anfragen an dieses System zu übermitteln.
          </p>
          <h4>Haftung</h4>
          <p>
            Media Juice übernimmt keine Garantie für die Funktion, Qualität,
            permanente Verfügbarkeit oder Abrufgeschwindigkeit des Dienstes.
            Media Juice behält sich das Recht vor, ohne Angabe von Gründen oder
            Einhaltung einer Frist, den Betrieb des Dienstes einzustellen, zu
            ändern, oder einzelne Nutzer von der Verwendung des Dienstes
            auszuschließen. Schadensersatzansprüche des Nutzers sind
            ausgeschlossen, soweit nachfolgend nichts anderes bestimmt ist. Dies
            gilt auch zugunsten der gesetzlichen Vertreter und
            Erfüllungsgehilfen von Media Juice. Vom Haftungsausschluss
            ausgenommen sind Schadensersatzansprüche aufgrund einer Verletzung
            des Lebens, des Körpers, der Gesundheit und Schadensersatzansprüche
            aus der Verletzung wesentlicher Vertragspflichten. Wesentliche
            Vertragspflichten sind solche, deren Erfüllung für die Erreichung
            des Ziels des Vertrags notwendig ist. Ebenfalls vom
            Haftungsausschluss ausgenommen ist die Haftung für Schäden, die auf
            einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung von
            Media Juice, gesetzlichen Vertreter oder Erfüllungsgehilfen von
            Media Juice beruhen. Vorschriften des Produkthaftungsgesetzes
            bleiben unberührt. Media Juice hat keinerlei Einfluss auf Webseiten
            Dritter und übernimmt daher keinerlei Gewähr oder Haftung, Garantie
            oder sonstige Verantwortung für die Richtigkeit, Vollständigkeit,
            Aktualität oder sonstige Eigenschaften für von Dritten
            bereitgestellten Inhalten (z.B. Produktinformationen oder Preise).
          </p>
          <h2>Datenschutzerklärung</h2>
          <h3>Datenschutz</h3>

          <p>
            Wir haben diese Datenschutzerklärung (Fassung 09.05.2020-311175631)
            verfasst, um Ihnen gemäß der Vorgaben der{' '}
            <a href='https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=311175631'>
              Datenschutz-Grundverordnung (EU) 2016/679
            </a>{' '}
            zu erklären, welche Informationen wir sammeln, wie wir Daten
            verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher
            dieser Webseite haben. Leider liegt es in der Natur der Sache, dass
            diese Erklärungen sehr technisch klingen, wir haben uns bei der
            Erstellung jedoch bemüht, die wichtigsten Dinge so einfach und klar
            wie möglich zu beschreiben.
          </p>
          <h3>1 Verantwortliche Stelle</h3>
          <p>
            Verantwortliche Stelle für die Erhebung, Verarbeitung und Nutzung
            Ihrer personenbezogenen Daten im Sinne der
            Datenschutzgrundverordnung (DSGVO) ist:
          </p>

          <img
            src='https://firebasestorage.googleapis.com/v0/b/amber-living-eu.appspot.com/o/images%2Fdatenschutz.jpg?alt=media&token=8383154a-96ad-40d4-95ac-57a854b87dca'
            alt='datenschutz'
          />
          <h3>Automatische Datenspeicherung</h3>

          <p>
            Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen
            automatisch erstellt und gespeichert, so auch auf dieser Webseite.
            Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert
            unser Webserver (Computer auf dem diese Webseite gespeichert ist)
            automatisch Daten wie
          </p>
          <p>
            - die Adresse (URL) der aufgerufenen Webseite <br />
            - Browser und Browserversion <br />
            - das verwendete Betriebssystem <br />
            - die Adresse (URL) der zuvor besuchten Seite (Referrer URL)
            <br />
            - den Hostname und die IP-Adresse des Geräts von welchem aus
            zugegriffen wird <br />
            - Datum und Uhrzeit
            <br />
          </p>
          <p>in Dateien (Webserver-Logfiles).</p>

          <h3>Cookies</h3>
          <p>
            Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu
            speichern. Im Folgenden erklären wir, was Cookies sind und warum Sie
            genutzt werden, damit Sie die folgende Datenschutzerklärung besser
            verstehen.
          </p>
          <h4>Was genau sind Cookies?</h4>
          <p>
            Immer wenn Sie durch das Internet surfen, verwenden Sie einen
            Browser. Bekannte Browser sind beispielsweise Chrome, Safari,
            Firefox, Internet Explorer und Microsoft Edge. Die meisten Webseiten
            speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt
            man Cookies.
          </p>
          <p>
            Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche
            Helferlein. Fast alle Webseiten verwenden Cookies. Genauer
            gesprochen sind es HTTP-Cookies, da es auch noch andere Cookies für
            andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien,
            die von unserer Website auf Ihrem Computer gespeichert werden. Diese
            Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem “Hirn”
            Ihres Browsers, untergebracht. Ein Cookie besteht aus einem Namen
            und einem Wert. Bei der Definition eines Cookies müssen zusätzlich
            ein oder mehrere Attribute angegeben werden.
          </p>
          <p>
            Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise
            Sprache oder persönliche Seiteneinstellungen. Wenn Sie unsere Seite
            wieder aufrufen, übermittelt Ihr Browser die „userbezogenen“
            Informationen an unsere Seite zurück. Dank der Cookies weiß unsere
            Website, wer Sie sind und bietet Ihnen Ihre gewohnte
            Standardeinstellung. In einigen Browsern hat jedes Cookie eine
            eigene Datei, in anderen wie beispielsweise Firefox sind alle
            Cookies in einer einzigen Datei gespeichert.
          </p>
          <p>
            Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies.
            Erstanbieter-Cookies werden direkt von unserer Seite erstellt,
            Drittanbieter-Cookies werden von Partner-Webseiten (z.B. Google
            Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da
            jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines
            Cookies variiert von ein paar Minuten bis hin zu ein paar Jahren.
            Cookies sind keine Software-Programme und enthalten keine Viren,
            Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf
            Informationen Ihres PCs zugreifen.
          </p>
          <p>So können zum Beispiel Cookie-Daten aussehen:</p>
          <p>
            - Name: _ga <br />
            - Ablaufzeit: 2 Jahre <br />
            - Verwendung: Unterscheidung der Webseitenbesucher <br />
            - Beispielhafter Wert: GA1.2.1326744211.152311175631 <br />
          </p>
          <p>Ein Browser sollte folgende Mindestgrößen unterstützen:</p>
          <p>
            - Ein Cookie soll mindestens 4096 Bytes enthalten können <br />- Pro
            Domain sollen mindestens 50 Cookies gespeichert werden können <br />
            - Insgesamt sollen mindestens 3000 Cookies gespeichert werden können{' '}
            <br />
          </p>
          <h3>Welche Arten von Cookies gibt es?</h3>
          <p>
            Die Frage welche Cookies wir im Speziellen verwenden, hängt von den
            verwendeten Diensten ab und wird in der folgenden Abschnitten der
            Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf
            die verschiedenen Arten von HTTP-Cookies eingehen.
            <br />
            Man kann 4 Arten von Cookies unterscheiden:
          </p>
          <h4>Unbedingt notwendige Cookies</h4>
          <p>
            Diese Cookies sind nötig, um grundlegende Funktionen der Website
            sicherzustellen. Zum Beispiel braucht es diese Cookies, wenn ein
            User ein Produkt in den Warenkorb legt, dann auf anderen Seiten
            weitersurft und später erst zur Kasse geht. Durch diese Cookies wird
            der Warenkorb nicht gelöscht, selbst wenn der User sein
            Browserfenster schließt.
          </p>
          <h4>Funktionelle Cookies</h4>
          <p>
            Diese Cookies sammeln Infos über das Userverhalten und ob der User
            etwaige Fehlermeldungen bekommt. Zudem werden mithilfe dieser
            Cookies auch die Ladezeit und das Verhalten der Website bei
            verschiedenen Browsern gemessen.
          </p>

          <h4>Zielorientierte Cookies </h4>
          <p>
            Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit.
            Beispielsweise werden eingegebene Standorte, Schriftgrößen oder
            Formulardaten gespeichert.
          </p>
          <h4>Werbe-Cookies</h4>
          <p>
            Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu
            dem User individuell angepasste Werbung zu liefern. Das kann sehr
            praktisch, aber auch sehr nervig sein. Üblicherweise werden Sie beim
            erstmaligen Besuch einer Webseite gefragt, welche dieser Cookiearten
            Sie zulassen möchten. Und natürlich wird diese Entscheidung auch in
            einem Cookie gespeichert.
          </p>

          <h4>Wie kann ich Cookies löschen? </h4>
          <p>
            Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst.
            Unabhängig von welchem Service oder welcher Website die Cookies
            stammen, haben Sie immer die Möglichkeit Cookies zu löschen, nur
            teilweise zuzulassen oder zu deaktivieren. Zum Beispiel können Sie
            Cookies von Drittanbietern blockieren, aber alle anderen Cookies
            zulassen. Wenn Sie feststellen möchten, welche Cookies in Ihrem
            Browser gespeichert wurden, wenn Sie Cookie-Einstellungen ändern
            oder löschen wollen, können Sie dies in Ihren Browser-Einstellungen
            finden:
          </p>

          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten{' '}
            </a>
            <br />
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari{' '}
            </a>
            <br />
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben{' '}
            </a>
            <br />
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies{' '}
            </a>
            <br />
            <a href='https://support.microsoft.com/de-at/help/4027947/microsoft-edge-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies{' '}
            </a>
            <br />
          </p>

          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie das Cookie erlauben oder nicht. Die
            Vorgangsweise ist je nach Browser verschieden. Am besten ist es Sie
            suchen die Anleitung in Google mit dem Suchbegriff “Cookies löschen
            Chrome” oder “Cookies deaktivieren Chrome” im Falle eines Chrome
            Browsers oder tauschen das Wort “Chrome” gegen den Namen Ihres
            Browsers, z.B. Edge, Firefox, Safari aus.{' '}
          </p>
          <h4>Wie sieht es mit meinem Datenschutz aus?</h4>
          <p>
            Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist
            festgehalten, dass das Speichern von Cookies eine Einwilligung des
            Website-Besuchers (also von Ihnen) verlangt. Innerhalb der EU-Länder
            gibt es allerdings noch sehr unterschiedliche Reaktionen auf diese
            Richtlinien. In Deutschland wurden die Cookie-Richtlinien nicht als
            nationales Recht umgesetzt. Stattdessen erfolgte die Umsetzung
            dieser Richtlinie weitgehend in § 15 Abs.3 des Telemediengesetzes
            (TMG).
          </p>

          <p>
            Wenn Sie mehr über Cookies wissen möchten und vor technischen
            Dokumentationen nicht zurückscheuen, empfehlen wir{' '}
            <a href='https://tools.ietf.org/html/rfc6265'>
              https://tools.ietf.org/html/rfc6265
            </a>
            , dem Request for Comments der Internet Engineering Task Force
            (IETF) namens “HTTP State Management Mechanism”.{' '}
          </p>

          <h4>Speicherung persönlicher Daten </h4>

          <p>
            Persönliche Daten, die Sie uns auf dieser Website elektronisch
            übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder
            andere persönlichen Angaben im Rahmen der Übermittlung eines
            Formulars oder Kommentaren im Blog, werden von uns gemeinsam mit dem
            Zeitpunkt und der IP-Adresse nur zum jeweils angegebenen Zweck
            verwendet, sicher verwahrt und nicht an Dritte weitergegeben.
          </p>
          <p>
            Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation
            mit jenen Besuchern, die Kontakt ausdrücklich wünschen und für die
            Abwicklung der auf dieser Webseite angebotenen Dienstleistungen und
            Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht
            weiter, können jedoch nicht ausschließen, dass diese Daten beim
            Vorliegen von rechtswidrigem Verhalten eingesehen werden.
          </p>
          <p>
            Wenn Sie uns persönliche Daten per E-Mail schicken – somit abseits
            dieser Webseite – können wir keine sichere Übertragung und den
            Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen, vertrauliche
            Daten niemals unverschlüsselt per E-Mail zu übermitteln.
          </p>
          <p>
            Die Rechtsgrundlage besteht nach Artikel{' '}
            <a href='https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=311175631'>
              6 Absatz 1 a DSGVO{' '}
            </a>
            (Rechtmäßigkeit der Verarbeitung) darin, dass Sie uns die
            Einwilligung zur Verarbeitung der von Ihnen eingegebenen Daten
            geben. Sie können diesen Einwilligung jederzeit widerrufen – eine
            formlose E-Mail reicht aus, Sie finden unsere Kontaktdaten im
            Impressum.
          </p>

          <h3>Rechte laut Datenschutzgrundverordnung </h3>
          <p>
            Ihnen stehen laut den Bestimmungen der DSGVO grunds&auml;tzlich die
            folgende Rechte zu:
          </p>
          <p>
            - Recht auf Berichtigung (Artikel 16 DSGVO)
            <br />
            - Recht auf L&ouml;schung (&bdquo;Recht auf Vergessenwerden&ldquo;)
            (Artikel 17 DSGVO)
            <br />
            - Recht auf Einschr&auml;nkung der Verarbeitung (Artikel 18 DSGVO)
            <br />
            - Recht auf Benachrichtigung &ndash; Mitteilungspflicht im
            Zusammenhang mit der Berichtigung oder L&ouml;schung
            personenbezogener Daten oder der Einschr&auml;nkung der Verarbeitung
            (Artikel 19 DSGVO)
            <br />
            - Recht auf Daten&uuml;bertragbarkeit (Artikel 20 DSGVO)
            <br />
            - Widerspruchsrecht (Artikel 21 DSGVO)
            <br />
            - Recht, nicht einer ausschlie&szlig;lich auf einer automatisierten
            Verarbeitung &mdash; einschlie&szlig;lich Profiling &mdash;
            beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)
            <br />
          </p>
          <p>
            Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
            Datenschutzrecht verst&ouml;&szlig;t oder Ihre
            datenschutzrechtlichen Anspr&uuml;che sonst in einer Weise verletzt
            worden sind, k&ouml;nnen Sie sich an die
            <a href='https://www.bfdi.bund.de'>
              Bundesbeauftragte f&uuml;r den Datenschutz und die
              Informationsfreiheit (BfDI)
            </a>{' '}
            wenden.
          </p>

          <h2>
            <strong>Auswertung des Besucherverhaltens</strong>
          </h2>
          <p>
            In der folgenden Datenschutzerklärung informieren wir Sie darüber,
            ob und wie wir Daten Ihres Besuchs dieser Website auswerten. Die
            Auswertung der gesammelten Daten erfolgt in der Regel anonym und wir
            können von Ihrem Verhalten auf dieser Website nicht auf Ihre Person
            schließen.
          </p>
          <p>
            Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu
            widersprechen erfahren Sie in der folgenden Datenschutzerklärung.
          </p>
          <h2>
            <strong>TLS-Verschlüsselung mit https</strong>
          </h2>
          <p>
            Wir verwenden https um Daten abhörsicher im Internet zu übertragen
            (Datenschutz durch Technikgestaltung
            <a href='https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=311175631'>
              Artikel 25 Absatz 1 DSGVO
            </a>
            ). Durch den Einsatz von TLS (Transport Layer Security), einem
            Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet
            können wir den Schutz vertraulicher Daten sicherstellen. Sie
            erkennen die Benutzung dieser Absicherung der Datenübertragung am
            kleinen Schloßsymbol links oben im Browser und der Verwendung des
            Schemas https (anstatt http) als Teil unserer Internetadresse.
          </p>
          <h2>
            <strong>Facebook-Pixel Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf unserer Webseite das Facebook-Pixel von Facebook.
            Dafür haben wir einen Code auf unserer Webseite implementiert. Der
            Facebook-Pixel ist ein Ausschnitt aus JavaScript-Code, der eine
            Ansammlung von Funktionen lädt, mit denen Facebook Ihre
            Userhandlungen verfolgen kann, sofern Sie über Facebook-Ads auf
            unsere Webseite gekommen sind. Wenn Sie beispielsweise ein Produkt
            auf unserer Webseite erwerben, wird das Facebook-Pixel ausgelöst und
            speichert Ihre Handlungen auf unserer Webseite in einem oder
            mehreren Cookies. Diese Cookies ermöglichen es Facebook Ihre
            Userdaten (Kundendaten wie IP-Adresse, User-ID) mit den Daten Ihres
            Facebook-Kontos abzugleichen. Dann löscht Facebook diese Daten
            wieder. Die erhobenen Daten sind für uns anonym und nicht einsehbar
            und werden nur im Rahmen von Werbeanzeigenschaltungen nutzbar. Wenn
            Sie selbst Facebook-User sind und angemeldet sind, wird der Besuch
            unserer Webseite automatisch Ihrem Facebook-Benutzerkonto
            zugeordnet.
          </p>
          <p>
            Wir wollen unsere Dienstleistungen bzw. Produkte nur jenen Menschen
            zeigen, die sich auch wirklich dafür interessieren. Mithilfe von
            Facebook-Pixel können unsere Werbemaßnahmen besser auf Ihre Wünsche
            und Interessen abgestimmt werden. So bekommen Facebook-User (sofern
            sie personalisierte Werbung erlaubt haben) passende Werbung zu
            sehen. Weiters verwendet Facebook die erhobenen Daten zu
            Analysezwecken und eigenen Werbeanzeigen.
          </p>
          <p>
            Im Folgenden zeigen wir Ihnen jene Cookies, die durch das Einbinden
            von Facebook-Pixel auf einer Testseite gesetzt wurden. Bitte
            beachten Sie, dass dies nur Beispiel-Cookies sind. Je nach
            Interaktion auf unserer Webseite werden unterschiedliche Cookies
            gesetzt.
          </p>
          <p>
            <strong>Name: </strong>
            _fbp
          </p>
          <p>
            <strong>Wert: </strong>
            fb.1.1568287647279.257405483-6311175631-7
          </p>
          <p>
            <strong>Verwendungszweck: </strong>
            Dieses Cookie verwendet Facebook, um Werbeprodukte anzuzeigen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>
            nach 3 Monaten
          </p>
          <p>
            <strong>Name: </strong>
            fr
          </p>
          <p>
            <strong>Wert: </strong>
            0aPf312HOS5Pboo2r..Bdeiuf…1.0.Bdeiuf.
          </p>
          <p>
            <strong>Verwendungszweck: </strong>
            Dieses Cookie wird verwendet, damit Facebook-Pixel auch ordentlich
            funktioniert.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>
            nach 3 Monaten
          </p>
          <p>
            <strong>Name: </strong>
            comment_author_50ae8267e2bdf1253ec1a5769f48e062311175631-3
          </p>
          <p>
            <strong>Wert: </strong>
            Name des Autors
          </p>
          <p>
            <strong>Verwendungszweck: </strong>
            Dieses Cookie speichert den Text und den Namen eines Users, der
            beispielsweise einen Kommentar hinterlässt.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>
            nach 12 Monaten
          </p>
          <p>
            <strong>Name: </strong>
            comment_author_url_50ae8267e2bdf1253ec1a5769f48e062
          </p>
          <p>
            <strong>Wert: </strong>
            https%3A%2F%2Fwww.testseite…%2F (URL des Autors)
          </p>
          <p>
            <strong>Verwendungszweck: </strong>
            Dieses Cookie speichert die URL der Website, die der User in einem
            Textfeld auf unserer Webseite eingibt.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>
            nach 12 Monaten
          </p>
          <p>
            <strong>Name: </strong>
            comment_author_email_50ae8267e2bdf1253ec1a5769f48e062
          </p>
          <p>
            <strong>Wert: </strong>
            E-Mail-Adresse des Autors
          </p>
          <p>
            <strong>Verwendungszweck: </strong>
            Dieses Cookie speichert die E-Mail-Adresse des Users, sofern er sie
            auf der Website bekannt gegeben hat.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>
            nach 12 Monaten
          </p>
          <p>
            <strong>Anmerkung: </strong>
            Die oben genannten Cookies beziehen sich auf ein individuelles
            Userverhalten. Speziell bei der Verwendung von Cookies sind
            Veränderungen bei Facebook nie auszuschließen.
          </p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre
            Einstellungen für Werbeanzeigen unter
            <a href='https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen'>
              https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
            </a>
            selbst verändern. Falls Sie kein Facebook-User sind, können Sie auf
            <a href='http://www.youronlinechoices.com/de/praferenzmanagement/?tid=311175631'>
              http://www.youronlinechoices.com/de/praferenzmanagement/
            </a>
            grundsätzlich Ihre nutzungsbasierte Online-Werbung verwalten. Dort
            haben Sie die Möglichkeit, Anbieter zu deaktivieren bzw. zu
            aktivieren.
          </p>
          <p>
            Wenn Sie mehr über den Datenschutz von Facebook erfahren wollen,
            empfehlen wir Ihnen die eigenen Datenrichtlinien des Unternehmens
            auf
            <a href='https://www.facebook.com/policy.php'>
              https://www.facebook.com/policy.php
            </a>
            .
          </p>
          <h2>
            <strong>
              Facebook Automatischer erweiterter Abgleich Datenschutzerklärung
            </strong>
          </h2>
          <p>
            Wir haben im Rahmen der Facebook-Pixel-Funktion auch den
            automatischen erweiterten Abgleich (engl. Automatic Advanced
            Matching) aktiviert. Diese Funktion des Pixels ermöglicht uns,
            gehashte E-Mails, Namen, Geschlecht, Stadt, Bundesland, Postleitzahl
            und Geburtsdatum oder Telefonnummer als zusätzliche Informationen an
            Facebook zu senden, sofern Sie uns diese Daten zur Verfügung
            gestellt haben. Diese Aktivierung ermöglicht uns Werbekampagnen auf
            Facebook noch genauer auf Menschen, die sich für unsere
            Dienstleistungen oder Produkte interessieren, anzupassen.
          </p>
          <h2>
            <strong>Google Fonts Lokal Datenschutzerklärung</strong>
          </h2>
          <p>
            Auf unserer Website nutzen wir Google Fonts der Firma Google Inc.
            Für den europäischen Raum ist das Unternehmen Google Ireland Limited
            (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Wir
            haben die Google-Schriftarten lokal, d.h. auf unserem Webserver –
            nicht auf den Servern von Google – eingebunden. Dadurch gibt es
            keine Verbindung zu Google-Servern und somit auch keine
            Datenübertragung oder Speicherung.
          </p>
          <h4>Was sind Google Fonts?</h4>
          <p>
            Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt
            es sich um ein interaktives Verzeichnis mit über 800 Schriftarten,
            die
            <a href='https://de.wikipedia.org/wiki/Google_LLC?tid=311175631'>
              Google
            </a>
            kostenlos bereitstellt. Mit Google Fonts könnte man Schriften
            nutzen, ohne sie auf den eigenen Server hochzuladen. Doch um
            diesbezüglich jede Informationsübertragung zu Google-Servern zu
            unterbinden, haben wir die Schriftarten auf unseren Server
            heruntergeladen. Auf diese Weise handeln wir datenschutzkonform und
            senden keine Daten an Google Fonts weiter.
          </p>
          <p>
            Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten
            Zugriff auf alle Schriftarten. Wir können also unlimitiert auf ein
            Meer an Schriftarten zugreifen und so das Optimum für unsere
            Webseite rausholen. Mehr zu Google Fonts und weiteren Fragen finden
            Sie auf
            <a href='https://developers.google.com/fonts/faq?tid=311175631'>
              https://developers.google.com/fonts/faq?tid=311175631
            </a>
            .
          </p>
          <h2>
            <strong>
              Eingebettete Social Media Elemente Datenschutzerklärung
            </strong>
          </h2>
          <p>
            Wir binden auf unserer Webseite Elemente von Social Media Diensten
            ein um Bilder, Videos und Texte anzuzeigen.
          </p>
          <p>
            Durch den Besuch von Seiten die diese Elemente darstellen, werden
            Daten von Ihrem Browser zum jeweiligen Social Media Dienst
            übertragen und dort gespeichert. Wir haben keinen Zugriff auf diese
            Daten.
          </p>
          <p>
            Die folgenden Links führen Sie zu den Seiten der jeweiligen Social
            Media Dienste wo erklärt wird, wie diese mit Ihren Daten umgehen:
          </p>
          <p>
            -Instagram-Datenschutzrichtlinie:
            <a href='https://help.instagram.com/519522125107875?tid=311175631'>
              https://help.instagram.com/519522125107875
            </a>
            <br />
            -Für YouTube gilt die Google Datenschutzerklärung:
            <a href='https://policies.google.com/privacy?hl=de&amp;tid=311175631'>
              https://policies.google.com/privacy?hl=de
            </a>
            <br />
            -Facebook-Datenrichtline:{' '}
            <a href='https://www.facebook.com/about/privacy?tid=311175631'>
              https://www.facebook.com/about/privacy
            </a>
            <br />
            -Twitter Datenschutzrichtlinie:{' '}
            <a href='https://twitter.com/de/privacy?tid=311175631'>
              https://twitter.com/de/privacy
            </a>
            <br />
          </p>
          <h2>
            <strong>Google Analytics Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf unserer Website das Analyse-Tracking Tool Google
            Analytics (GA) des amerikanischen Unternehmens Google Inc. Für den
            europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon
            House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
            verantwortlich. Google Analytics sammelt Daten über Ihre Handlungen
            auf unserer Website. Wenn Sie beispielsweise einen Link anklicken,
            wird diese Aktion in einem Cookie gespeichert und an Google
            Analytics versandt. Mithilfe der Berichte, die wir von Google
            Analytics erhalten, können wir unsere Website und unser Service
            besser an Ihre Wünsche anpassen. Im Folgenden gehen wir näher auf
            das Tracking Tool ein und informieren Sie vor allem darüber, welche
            Daten gespeichert werden und wie Sie das verhindern können.
          </p>
          <h3>
            <strong>Was ist Google Analytics?</strong>
          </h3>
          <p>
            Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse
            unserer Website dient. Damit Google Analytics funktioniert, wird ein
            Tracking-Code in den Code unserer Website eingebaut. Wenn Sie unsere
            Website besuchen, zeichnet dieser Code verschiedene Handlungen auf,
            die Sie auf unserer Website ausführen. Sobald Sie unsere Website
            verlassen, werden diese Daten an die Google-Analytics-Server
            gesendet und dort gespeichert.
          </p>
          <p>
            Google verarbeitet die Daten und wir bekommen Berichte über Ihr
            Userverhalten. Dabei kann es sich unter anderem um folgende Berichte
            handeln:
          </p>
          <p>
            -Zielgruppenberichte: Über Zielgruppenberichte lernen wir unsere
            User besser kennen und wissen genauer, wer sich für unser Service
            interessiert.
            <br />
            -Anzeigeberichte: Durch Anzeigeberichte können wir unsere
            Onlinewerbung leichter analysieren und verbessern.
            <br />
            -Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche
            Informationen darüber, wie wir mehr Menschen für unser Service
            begeistern können.
            <br />
            -Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website
            interagieren. Wir können nachvollziehen welchen Weg Sie auf unserer
            Seite zurücklegen und welche Links Sie anklicken.
            <br />
            -Conversionsberichte: Conversion nennt man einen Vorgang, bei dem
            Sie aufgrund einer Marketing-Botschaft eine gewünschte Handlung
            ausführen. Zum Beispiel, wenn Sie von einem reinen Websitebesucher
            zu einem Käufer oder Newsletter-Abonnent werden. Mithilfe dieser
            Berichte erfahren wir mehr darüber, wie unsere Marketing-Maßnahmen
            bei Ihnen ankommen. So wollen wir unsere Conversionrate steigern.
            <br />
            -Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf
            unserer Website passiert. Zum Beispiel sehen wir wie viele User
            gerade diesen Text lesen.
            <br />
          </p>
          <h3>
            <strong>
              Warum verwenden wir Google Analytics auf unserer Webseite?
            </strong>
          </h3>
          <p>
            Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen das
            bestmögliche Service bieten. Die Statistiken und Daten von Google
            Analytics helfen uns dieses Ziel zu erreichen.
          </p>
          <p>
            Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von
            den Stärken und Schwächen unserer Website. Einerseits können wir
            unsere Seite so optimieren, dass sie von interessierten Menschen auf
            Google leichter gefunden wird. Andererseits helfen uns die Daten,
            Sie als Besucher besser zu verstehen. Wir wissen somit sehr genau,
            was wir an unserer Website verbessern müssen, um Ihnen das
            bestmögliche Service zu bieten. Die Daten dienen uns auch, unsere
            Werbe- und Marketing-Maßnahmen individueller und kostengünstiger
            durchzuführen. Schließlich macht es nur Sinn, unsere Produkte und
            Dienstleistungen Menschen zu zeigen, die sich dafür interessieren.
          </p>
          <h3>
            <strong>
              Welche Daten werden von Google Analytics gespeichert?
            </strong>
          </h3>
          <p>
            Google Analytics erstellt mithilfe eines Tracking-Codes eine
            zufällige, eindeutige ID, die mit Ihrem Browser-Cookie verbunden
            ist. So erkennt Sie Google Analytics als neuen User. Wenn Sie das
            nächste Mal unsere Seite besuchen, werden Sie als „wiederkehrender“
            User erkannt. Alle gesammelten Daten werden gemeinsam mit dieser
            User-ID gespeichert. So ist es überhaupt erst möglich pseudonyme
            Userprofile auszuwerten.
          </p>
          <p>
            Durch Kennzeichnungen wie Cookies und App-Instanz-IDs werden Ihre
            Interaktionen auf unserer Website gemessen. Interaktionen sind alle
            Arten von Handlungen, die Sie auf unserer Website ausführen. Wenn
            Sie auch andere Google-Systeme (wie z.B. ein Google-Konto) nützen,
            können über Google Analytics generierte Daten mit
            Drittanbieter-Cookies verknüpft werden. Google gibt keine Google
            Analytics-Daten weiter, außer wir als Websitebetreiber genehmigen
            das. Zu Ausnahmen kann es kommen, wenn es gesetzlich erforderlich
            ist.
          </p>
          <p>Folgende Cookies werden von Google Analytics verwendet:</p>
          <p>
            <strong>Name: </strong> _ga
          </p>
          <p>
            <strong>Wert: </strong>2.1326744211.152311175631-5
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Standardmäßig verwendet
            analytics.js das Cookie _ga, um die User-ID zu speichern.
            Grundsätzlich dient es zur Unterscheidung der Webseitenbesucher.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Jahren
          </p>
          <p>
            <strong>Name: </strong> _gid
          </p>
          <p>
            <strong>Wert: </strong>2.1687193234.152311175631-1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie dient auch zur
            Unterscheidung der Webseitenbesucher.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 24 Stunden
          </p>
          <p>
            <strong>Name: </strong> _gat_gtag_UA_&lt;property-id&gt;
          </p>
          <p>
            <strong>Wert: </strong> 1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Wird zum Senken der
            Anforderungsrate verwendet. Wenn Google Analytics über den Google
            Tag Manager bereitgestellt wird, erhält dieser Cookie den Namen
            _dc_gtm_ &lt;property-id&gt;.
          </p>
          <p>
            <strong>Ablaufdatum: </strong>nach 1 Minute
          </p>
          <p>
            <strong>Name: </strong> AMP_TOKEN
          </p>
          <p>
            <strong>Wert: </strong> keine Angaben
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie hat einen Token, mit
            dem eine User ID vom AMP-Client-ID-Dienst abgerufen werden kann.
            Andere mögliche Werte weisen auf eine Abmeldung, eine Anfrage oder
            einen Fehler hin.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 30 Sekunden bis zu einem Jahr
          </p>
          <p>
            <strong>Name: </strong> __utma
          </p>
          <p>
            <strong>Wert: </strong>1564498958.1564498958.1564498958.1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Mit diesem Cookie kann man Ihr
            Verhalten auf der Website verfolgen und die Leistung messen. Das
            Cookie wird jedes Mal aktualisiert, wenn Informationen an Google
            Analytics gesendet werden.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Jahren
          </p>
          <p>
            <strong>Name: </strong> __utmt
          </p>
          <p>
            <strong>Wert: </strong> 1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie wird wie
            _gat_gtag_UA_&lt;property-id&gt; zum Drosseln der Anforderungsrate
            verwendet.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 10 Minuten
          </p>
          <p>
            <strong>Name: </strong> __utmb
          </p>
          <p>
            <strong>Wert: </strong>3.10.1564498958
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie wird verwendet, um
            neue Sitzungen zu bestimmen. Es wird jedes Mal aktualisiert, wenn
            neue Daten bzw. Infos an Google Analytics gesendet werden.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 30 Minuten
          </p>
          <p>
            <strong>Name: </strong> __utmc
          </p>
          <p>
            <strong>Wert: </strong> 167421564
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie wird verwendet, um
            neue Sitzungen für wiederkehrende Besucher festzulegen. Dabei
            handelt es sich um ein Session-Cookie, und es wird nur solange
            gespeichert, bis Sie den Browser wieder schließen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> Nach Schließung des Browsers
          </p>
          <p>
            <strong>Name: </strong> __utmz
          </p>
          <p>
            <strong>Wert: </strong> m|utmccn=(referral)|utmcmd=referral|utmcct=/
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie wird verwendet, um
            die Quelle des Besucheraufkommens auf unserer Website zu
            identifizieren. Das heißt, das Cookie speichert, von wo Sie auf
            unsere Website gekommen sind. Das kann eine andere Seite bzw. eine
            Werbeschaltung gewesen sein.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 6 Monaten
          </p>
          <p>
            <strong>Name: </strong> __utmv
          </p>
          <p>
            <strong>Wert: </strong> keine Angabe
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie wird verwendet, um
            benutzerdefinierte Userdaten zu speichern. Es wird immer
            aktualisiert, wenn Informationen an Google Analytics gesendet
            werden.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Jahren
          </p>
          <p>
            <strong>Anmerkung: </strong> Diese Aufzählung kann keinen Anspruch
            auf Vollständigkeit erheben, da Google die Wahl seiner Cookies immer
            wieder verändert.
          </p>
          <p>
            Hier zeigen wir Ihnen einen Überblick über die wichtigsten Daten,
            die mit Google Analytics erhoben werden:
          </p>
          <p>
            <strong>Heatmaps: </strong> Google legt sogenannte Heatmaps an. Über
            Heatmaps sieht man genau jene Bereiche, die Sie anklicken. So
            bekommen wir Informationen, wo Sie auf unserer Seite „unterwegs“
            sind.
          </p>
          <p>
            <strong>Sitzungsdauer: </strong> Als Sitzungsdauer bezeichnet Google
            die Zeit, die Sie auf unserer Seite verbringen, ohne die Seite zu
            verlassen. Wenn Sie 20 Minuten inaktiv waren, endet die Sitzung
            automatisch.
          </p>
          <p>
            <strong>Absprungrate</strong> (engl. Bouncerate): Von einem Absprung
            ist die Rede, wenn Sie auf unserer Website nur eine Seite ansehen
            und dann unsere Website wieder verlassen.
          </p>
          <p>
            <strong>Kontoerstellung: </strong> Wenn Sie auf unserer Website ein
            Konto erstellen bzw. eine Bestellung machen, erhebt Google Analytics
            diese Daten.
          </p>
          <p>
            <strong>IP-Adresse: </strong> Die IP-Adresse wird nur in gekürzter
            Form dargestellt, damit keine eindeutige Zuordnung möglich ist.
          </p>
          <p>
            <strong>Standort: </strong> Über die IP-Adresse kann das Land und
            Ihr ungefährer Standort bestimmt werden. Diesen Vorgang bezeichnet
            man auch als IP- Standortbestimmung.
          </p>
          <p>
            <strong>Technische Informationen: </strong> Zu den technischen
            Informationen zählen unter anderem Ihr Browsertyp, Ihr
            Internetanbieter oder Ihre Bildschirmauflösung.
          </p>
          <p>
            <strong>Herkunftsquelle: </strong> Google Analytics beziehungsweise
            uns, interessiert natürlich auch über welche Website oder welche
            Werbung Sie auf unsere Seite gekommen sind.
          </p>
          <p>
            Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen
            von Medien (z.B., wenn Sie ein Video über unsere Seite abspielen),
            das Teilen von Inhalten über Social Media oder das Hinzufügen zu
            Ihren Favoriten. Die Aufzählung hat keinen Vollständigkeitsanspruch
            und dient nur zu einer allgemeinen Orientierung der Datenspeicherung
            durch Google Analytics.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Google hat Ihre Server auf der ganzen Welt verteilt. Die meisten
            Server befinden sich in Amerika und folglich werden Ihre Daten meist
            auf amerikanischen Servern gespeichert. Hier können Sie genau
            nachlesen wo sich die Google-Rechenzentren befinden:
            <a href='https://www.google.com/about/datacenters/inside/locations/?hl=de'>
              https://www.google.com/about/datacenters/inside/locations/?hl=de
            </a>
          </p>
          <p>
            Ihre Daten werden auf verschiedenen physischen Datenträgern
            verteilt. Das hat den Vorteil, dass die Daten schneller abrufbar
            sind und vor Manipulation besser geschützt sind. In jedem
            Google-Rechenzentrum gibt es entsprechende Notfallprogramme für Ihre
            Daten. Wenn beispielsweise die Hardware bei Google ausfällt oder
            Naturkatastrophen Server lahmlegen, bleibt das Risiko einer
            Dienstunterbrechung bei Google dennoch gering.
          </p>
          <p>
            Standardisiert ist bei Google Analytics eine Aufbewahrungsdauer
            Ihrer Userdaten von 26 Monaten eingestellt. Dann werden Ihre
            Userdaten gelöscht. Allerdings haben wir die Möglichkeit, die
            Aufbewahrungsdauer von Nutzdaten selbst zu wählen. Dafür stehen uns
            fünf Varianten zur Verfügung:
          </p>
          <p>
            -Löschung nach 14 Monaten
            <br />
            -Löschung nach 26 Monaten
            <br />
            -Löschung nach 38 Monaten
            <br />
            -Löschung nach 50 Monaten
            <br />
            -Keine automatische Löschung
            <br />
          </p>
          <p>
            Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat
            die Daten gelöscht. Diese Aufbewahrungsdauer gilt für Ihre Daten,
            die mit Cookies, Usererkennung und Werbe-IDs (z.B. Cookies der
            DoubleClick-Domain) verknüpft sind. Berichtergebnisse basieren auf
            aggregierten Daten und werden unabhängig von Nutzerdaten
            gespeichert. Aggregierte Daten sind eine Zusammenschmelzung von
            Einzeldaten zu einer größeren Einheit.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Nach dem Datenschutzrecht der Europäischen Union haben Sie das
            Recht, Auskunft über Ihre Daten zu erhalten, sie zu aktualisieren,
            zu löschen oder einzuschränken. Mithilfe des Browser-Add-ons zur
            Deaktivierung von Google Analytics-JavaScript (ga.js, analytics.js,
            dc.js) verhindern Sie, dass Google Analytics Ihre Daten verwendet.
            Das Browser-Add-on können Sie unter
            <a href='https://tools.google.com/dlpage/gaoptout?hl=de'>
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>{' '}
            runterladen und installieren. Beachten Sie bitte, dass durch dieses
            Add-on nur die Datenerhebung durch Google Analytics deaktiviert
            wird.
          </p>
          <p>
            Falls Sie grundsätzlich Cookies (unabhängig von Google Analytics)
            deaktivieren, löschen oder verwalten wollen, gibt es für jeden
            Browser eine eigene Anleitung:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Google Analytics ist aktiver Teilnehmer beim EU-U.S. Privacy Shield
            Framework, wodurch der korrekte und sichere Datentransfer
            persönlicher Daten geregelt wird. Mehr Informationen dazu finden Sie
            auf
            <a href='https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI'>
              https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;tid=311175631
            </a>
            . Wir hoffen wir konnten Ihnen die wichtigsten Informationen rund um
            die Datenverarbeitung von Google Analytics näherbringen. Wenn Sie
            mehr über den Tracking-Dienst erfahren wollen, empfehlen wir diese
            beiden Links:
            <a href='http://www.google.com/analytics/terms/de.html'>
              http://www.google.com/analytics/terms/de.html
            </a>{' '}
            und
            <a href='https://support.google.com/analytics/answer/6004245?hl=de'>
              https://support.google.com/analytics/answer/6004245?hl=de
            </a>
            .
          </p>
          <h2>
            <strong>Google Analytics IP-Anonymisierung</strong>
          </h2>
          <p>
            Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von
            Google Analytics implementiert. Diese Funktion wurde von Google
            entwickelt, damit diese Webseite die geltenden
            Datenschutzbestimmungen und Empfehlungen der lokalen
            Datenschutzbehörden einhalten kann, wenn diese eine Speicherung der
            vollständigen IP-Adresse untersagen. Die Anonymisierung bzw.
            Maskierung der IP findet statt, sobald die IP-Adressen im Google
            Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine
            Speicherung oder Verarbeitung der Daten stattfindet.
          </p>
          <p>
            Mehr Informationen zur IP-Anonymisierung finden Sie auf{' '}
            <a href='https://support.google.com/analytics/answer/2763052?hl=de'>
              https://support.google.com/analytics/answer/2763052?hl=de
            </a>
            .
          </p>
          <h2>
            <strong>
              Google Analytics Berichte zu demografischen Merkmalen und
              Interessen
            </strong>
          </h2>
          <p>
            Wir haben in Google Analytics die Funktionen für Werbeberichte
            eingeschaltet. Die Berichte zu demografischen Merkmalen und
            Interessen enthalten Angaben zu Alter, Geschlecht und Interessen.
            Damit können wir uns – ohne diese Daten einzelnen Personen zuordnen
            zu können – ein besseres Bild von unseren Nutzern machen. Mehr über
            die Werbefunktionen erfahren Sie
            <a href='https://support.google.com/analytics/answer/3450482?hl=de_AT&amp;utm_id=ad'>
              auf
              https://support.google.com/analytics/answer/3450482?hl=de_AT&amp;utm_id=ad
            </a>
            .
          </p>
          <p>
            Sie können die Nutzung der Aktivitäten und Informationen Ihres
            Google Kontos unter “Einstellungen für Werbung” auf
            <a href='https://adssettings.google.com/authenticated'>
              https://adssettings.google.com/authenticated
            </a>{' '}
            per Checkbox beenden.
          </p>
          <h2>
            <strong>Google Analytics Deaktivierungslink</strong>
          </h2>
          <p>
            Wenn Sie auf folgenden <strong>Deaktivierungslink</strong> klicken,
            können Sie verhindern, dass Google weitere Besuche auf dieser
            Webseite erfasst. Achtung: Das Löschen von Cookies, die Nutzung des
            Inkognito/Privatmodus Ihres Browsers, oder die Nutzung eines anderen
            Browsers führt dazu, dass wieder Daten erhoben werden.
          </p>
          <p>Google Analytics deaktivieren</p>
          <h2>
            <strong>Google Analytics Zusatz zur Datenverarbeitung</strong>
          </h2>
          <p>
            Wir haben mit Google einen Direktkundenvertrag zur Verwendung von
            Google Analytics abgeschlossen, indem wir den “Zusatz zur
            Datenverarbeitung” in Google Analytics akzeptiert haben.
          </p>
          <p>
            Mehr über den Zusatz zur Datenverarbeitung für Google Analytics
            finden Sie hier:
            <a href='https://support.google.com/analytics/answer/3379636?hl=de&amp;utm_id=ad'>
              https://support.google.com/analytics/answer/3379636?hl=de&amp;utm_id=ad
            </a>
          </p>
          <h2>
            <strong>
              Google Analytics Google-Signale Datenschutzerklärung
            </strong>
          </h2>
          <p>
            Wir haben in Google Analytics die Google-Signale aktiviert. So
            werden die bestehenden Google-Analytics-Funktionen (Werbeberichte,
            Remarketing, gerätübergreifende Berichte und Berichte zu Interessen
            und demografische Merkmale) aktualisiert, um zusammengefasste und
            anonymisierte Daten von Ihnen zu erhalten, sofern Sie
            personalisierte Anzeigen in Ihrem Google-Konto erlaubt haben.
          </p>
          <p>
            Das besondere daran ist, dass es sich dabei um ein
            Cross-Device-Tracking handelt. Das heißt Ihre Daten können
            geräteübergreifend analysiert werden. Durch die Aktivierung von
            Google-Signale werden Daten erfasst und mit dem Google-Konto
            verknüpft. Google kann dadurch zum Beispiel erkennen, wenn Sie auf
            unsere Webseite über ein Smartphone ein Produkt ansehen und erst
            später über einen Laptop das Produkt kaufen. Dank der Aktivierung
            von Google-Signale können wir gerätübergreifende
            Remarketing-Kampagnen starten, die sonst in dieser Form nicht
            möglich wären. Remarketing bedeutet, dass wir Ihnen auch auf anderen
            Webseiten unser Angebot zeigen können.
          </p>
          <p>
            In Google Analytics werden zudem durch die Google-Signale weitere
            Besucherdaten wie Standort, Suchverlauf, YouTube-Verlauf und Daten
            über Ihre Handlungen auf unserer Webseite, erfasst. Wir erhalten
            dadurch von Google bessere Werbeberichte und nützlichere Angaben zu
            Ihren Interessen und demografischen Merkmalen. Dazu gehören Ihr
            Alter, welche Sprache sie sprechen, wo Sie wohnen oder welchem
            Geschlecht Sie angehören. Weiters kommen auch noch soziale Kriterien
            wie Ihr Beruf, Ihr Familienstand oder Ihr Einkommen hinzu. All diese
            Merkmal helfen Google Analytics Personengruppen bzw. Zielgruppen zu
            definieren.
          </p>
          <p>
            Die Berichte helfen uns auch Ihr Verhalten, Ihre Wünsche und
            Interessen besser einschätzen zu können. Dadurch können wir unsere
            Dienstleistungen und Produkte für Sie optimieren und anpassen. Diese
            Daten laufen standardmäßig nach 26 Monaten ab. Bitte beachten Sie,
            dass diese Datenerfassung nur erfolgt, wenn Sie personalisierte
            Werbung in Ihrem Google-Konto zugelassen haben. Es handelt sich
            dabei immer um zusammengefasste und anonyme Daten und nie um Daten
            einzelner Personen. In Ihrem Google-Konto können Sie diese Daten
            verwalten bzw. auch löschen.
          </p>
          <h4>
            <strong>Google Optimize</strong>
          </h4>
          <p>
            Wir setzen auf unserer Internetseite den Webanalysedienst Google
            Optimize der Google Inc., 1600 Amphitheatre Parkway, Mountain View,
            CA 94043 ein. Um Ihnen ideale Darstellungen und Funktionen anbieten
            zu können, setzen wir für unsere Angebote auf A/B-Tests sowie
            Multivariate Tests. A/B-Tests (manchmal auch{' '}
            <a href='https://support.google.com/optimize/answer/6211939#ab_test'>
              A/B/n-Tests
            </a>{' '}
            genannt) sind nach dem Zufallsprinzip ausgewählte Tests mit zwei
            oder mehr Varianten derselben Webseite (A und B). Variante A ist
            dabei das Original. Die Varianten B bis n enthalten jeweils
            mindestens ein abgeändertes Element, etwa eine andersfarbige
            Call-to-Action-Schaltfläche. Bei einigen Tests handelt es sich bei
            Variante B um eine komplett unterschiedliche Version einer Webseite.
            Bei multivariaten Tests (
            <a href='https://support.google.com/optimize/answer/6211939#multivariate_test'>
              MVT
            </a>
            ) werden Varianten von ein oder mehr Elementen gleichzeitig
            getestet, um zu ermitteln, welche Kombination am besten abschneidet.
            Anstatt wie bei A/B-Tests die effektivste Seitenvariante
            herauszustellen, wird bei multivariaten Tests die effektivste
            Variante jedes Elements ermittelt. Außerdem werden die Interaktionen
            zwischen den Elementen analysiert.
          </p>
          <p>
            Google Optimize analysiert die Nutzung dieser verschiedenen
            Varianten und hilft uns, ihre Benutzerfreundlichkeit zu verbessern.
            Dieser Service verwendet die durch Google Analytics (vgl. Ziff. 6.2
            Google Analytics) erhobenen Daten und setzt Cookies, um den Browser
            eines Besuchers zu identifizieren und die Nutzung dieser Webseite zu
            analysieren. Die Cookies sammeln keine personenbezogenen Daten.
          </p>
          <p>
            Mehr Informationen darüber, wie Google Optimize Ihre Daten
            verarbeitet, finden Sie unter
          </p>
          <p>
            <a href='https://www.google.com/analytics/optimize/features/'>
              https://www.google.com/analytics/optimize/features/
            </a>
          </p>
          <p>
            Sie können die Erfassung der durch das Cookie erzeugten und auf Ihre
            Nutzung der Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an
            Google sowie die Verarbeitung dieser Daten durch Google verhindern,
            indem sie das unter dem folgenden Link verfügbare Browser-Plugin
            herunterladen und installieren:
          </p>
          <p>
            <a href='https://tools.google.com/dlpage/gaoptout?hl=de'>
              http://tools.google.com/dlpage/gaoptout?hl=de
            </a>
            .
          </p>
          <p> </p>
          <p>
            <strong>Google Tag-Manager</strong>
          </p>
          <p>
            Unsere Website verwendet den Google Tag-Manager. Der Tag Manager
            dient der Verwaltung von Tracking-Tools und weiteren Diensten,
            sogenannten Website-Tags. Ein Tag ist ein Element, das im Quelltext
            unserer Website hinterlegt wird, um beispielsweis vorgegebene
            Nutzungsdaten zu erfassen. Der Google-Tag-Manger kommt ohne den
            Einsatz von Cookies aus und erfasst keine personenbezogenen Daten.
            Der Google Tag-Manager sorgt für die Auslösung anderer Tags, die
            ihrerseits unter Umständen Daten erfassen. Teilweise werden die
            Daten auf einem Google-Server in den USA gespeichert. Wenn auf
            Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen wurde,
            bleibt diese für alle Tracking-Tags bestehen, die mit Google Tag
            Manager implementiert werden. Nähere Informationen findest du
            zusätzlich in den Informationen von Google zum Tag-Manager{' '}
            <a href='https://support.google.com/tagmanager/answer/6102821?hl=de&amp;ref_topic=3441530'>
              https://support.google.com/tagmanager/answer/6102821?hl=de&amp;ref_topic=3441530
            </a>
          </p>
          <p> </p>
          <p>
            <strong> Google Signals</strong>
          </p>
          <p>
            Unsere Website setzt zur Optimierung unseres Onlineangebotes im
            Sinne des Art. 6 Abs. 1 lit. f. DSGVO den Webanalysedienst Google
            Signals ein. Google stellt mit Signals Berichte über die
            geräteübergreifenden Nutzeranzahlen, sowie zu verschiedenen Gruppen
            von Nutzern zur Verfügung, welche auf unterschiedlichen
            Gerätekombinationen basieren. Google verwendet die Daten der Nutzer,
            die in ihren Google-Konto-Einstellungen die Option „personalisierte
            Werbung“ aktiviert haben. Google Signals wird nur mit aktivierter
            IP-Anonymisierung eingesetzt. Das bedeutet, dass die IP-Adresse der
            Nutzer innerhalb der Mitgliedsstaaten der EU und des Europäischen
            Wirtschaftsraum gekürzt wird. Dadurch entfällt der Personenbezug
            deiner IP-Adresse. Es können keine Rückschlüsse auf die Identität
            eines einzelnen Nutzers gezogen werden. Der Erfassung durch Google
            Signals kann jederzeit widersprochen werden, indem der
            Seitenbesucher "personalisierte Werbung" in seinem Google Konto
            deaktiviert:{' '}
            <a href='https://support.google.com/ads/answer/2662922?hl=de'>
              https://support.google.com/ads/answer/2662922?hl=de
            </a>
            .
          </p>
          <p> </p>
          <p>
            <strong>Google Remarketing</strong>
          </p>
          <p>
            Unsere Website verwendet die Google Remarketing Funktion. Dieser
            Dienst verwendet Cookies und vergleichbare Technologien, um dir
            individualisierte Werbebotschaften auf Websites anzuzeigen, die mit
            Google zusammenarbeiten. Cookies und vergleichbare Technologien
            werden auch zur Durchführung der Analyse der Website-Nutzung, welche
            die Grundlage für die Erstellung der interessenbezogenen
            Werbeanzeigen bildet, verwendet. Die in diesem Zusammenhang
            anfallenden Daten können von Google zur Auswertung an einen Server
            in den USA übertragen und dort gespeichert werden. Wie oben
            dargestellt, können Sie Ihren Browser so konfigurieren, dass er
            Cookies abweist, oder Sie können die Erfassung der durch die Cookies
            erzeugten und auf Ihre Nutzung dieser Website bezogenen Daten sowie
            die Verarbeitung dieser Daten durch Google verhindern, indem Sie die
            Anzeigenvorgaben aufrufen und die Schalter für Personalisierung auf
            „Aus“ setzen{' '}
            <a href='https://adssettings.google.com/authenticated'>
              https://adssettings.google.com/authenticated
            </a>
            .
          </p>
          <p> </p>
          <h2>
            <strong>Google AdSense Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf dieser Website Google AdSense. Das ist ein
            Anzeigenprogramm der Firma Google Inc. In Europa ist das Unternehmen
            Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
            Irland) für alle Google-Dienste verantwortlich. Mit Google AdSense
            können wir auf dieser Webseite Werbeanzeigen einblenden, die zu
            unserem Thema passen. So bieten wir Ihnen Anzeigen, die im Idealfall
            einen richtigen Mehrwert für Sie darstellen. Im Zuge dieser
            Datenschutzerklärung über Google AdSense erklären wir Ihnen, warum
            wir Google AdSense auf unserer Webseite verwenden, welche Daten von
            Ihnen verarbeitet und gespeichert werden und wie Sie diese
            Datenspeicherung unterbinden können.
          </p>
          <h3>
            <strong>Was ist Google AdSense?</strong>
          </h3>
          <p>
            Das Werbeprogramm Google AdSense gibt es mittlerweile seit 2003. Im
            Gegensatz zu Google Ads (früher: Google AdWords) kann man hier nicht
            selbst Werbung schalten. Über Google AdSense werden Werbeanzeigen
            auf Webseiten, wie zum Beispiel auf unserer, ausgespielt. Der größte
            Vorteil dieses Werbedienstes im Vergleich zu manch anderen ist, dass
            Ihnen Google AdSense nur Anzeigen zeigt, die zu unseren Inhalten
            passen. Google hat einen eigenen Algorithmus, der berechnet, welche
            Werbeanzeigen Sie zu Gesicht bekommen. Natürlich wollen wir Ihnen
            nur Werbung bieten, die Sie auch interessiert und Ihnen einen
            Mehrwert bietet. Google überprüft anhand Ihrer Interessen bzw. Ihres
            Userverhaltens und anhand unseres Angebots, welche Werbeanzeigen für
            unsere Webseite und für unserer User geeignet sind. An dieser Stelle
            wollen wir auch gleich erwähnen, dass wir für die Auswahl der
            Werbeanzeigen nicht verantwortlich sind. Wir bieten mit unserer
            Webseite lediglich die Werbefläche an. Die Auswahl der angezeigten
            Werbung trifft Google. Seit August 2013 werden die Anzeigen auch an
            die jeweilige Benutzeroberfläche angepasst. Das heißt, egal ob Sie
            von Ihrem Smartphone, Ihrem PC oder Laptop unsere Webseite besuchen,
            die Anzeigen passen sich an Ihr Endgerät an.
          </p>
          <h3>
            <strong>
              Warum verwenden wir Google AdSense auf unserer Webseite?
            </strong>
          </h3>
          <p>
            Das Betreiben einer hochwertigen Webseite erfordert viel Hingabe und
            großen Einsatz. Im Grunde sind wir mit der Arbeit an unserer
            Webseite nie fertig. Wir versuchen stets unsere Seite zu pflegen und
            so aktuell wie möglich zu halten. Natürlich wollen wir mit dieser
            Arbeit auch einen wirtschaftlichen Erfolg erzielen. Darum haben wir
            uns für Werbeanzeigen als Einnahmequelle entschieden. Das Wichtigste
            für uns ist allerdings, Ihren Besuch auf unserer Webseite durch
            diese Anzeigen nicht zu stören. Mithilfe von Google AdSense wird
            Ihnen nur Werbung angeboten, die zu unseren Themen und Ihren
            Interessen passt.
          </p>
          <p>
            Ähnlich wie bei der Google-Indexierung für eine Webseite, untersucht
            ein Bot den entsprechenden Content und die entsprechenden Angebote
            unserer Webseite. Dann werden die Werbeanzeigen inhaltlich angepasst
            und auf der Webseite präsentiert. Neben den inhaltlichen
            Überschneidungen zwischen Anzeige und Webseiten-Angebot unterstützt
            AdSense auch interessensbezogenes Targeting. Das bedeutet, dass
            Google auch Ihre Daten dazu verwendet, um auf Sie zugeschnittene
            Werbung anzubieten. So erhalten Sie Werbung, die Ihnen im Idealfall
            einen echten Mehrwert bietet und wir haben eine höhere Chance ein
            bisschen etwas zu verdienen.
          </p>
          <h3>
            <strong>Welche Daten werden von Google AdSense gespeichert?</strong>
          </h3>
          <p>
            Damit Google AdSense eine maßgeschneiderte, auf Sie angepasste
            Werbung anzeigen kann, werden unter anderem Cookies verwendet.
            Cookies sind kleine Textdateien, die bestimmte Informationen auf
            Ihrem Computer speichern.
          </p>
          <p>
            In AdSense sollen Cookies bessere Werbung ermöglichen. Die Cookies
            enthalten keine personenidentifizierbaren Daten. Hierbei ist
            allerdings zu beachten, dass Google Daten wie zum Beispiel
            “Pseudonyme Cookie-IDs” (Name oder anderes Identifikationsmerkmal
            wird durch ein Pseudonym ersetzt) oder IP-Adressen als nicht
            personenidentifizierbare Informationen ansieht. Im Rahmen der DSGVO
            können diese Daten allerdings als personenbezogene Daten gelten.
            Google AdSense sendet nach jeder Impression (das ist immer dann der
            Fall, wenn Sie eine Anzeige sehen), jedem Klick und jeder anderen
            Aktivität, die zu einem Aufruf der Google AdSense-Server führt, ein
            Cookie an den Browser. Sofern der Browser das Cookie akzeptiert,
            wird es dort gespeichert.
          </p>
          <p>
            Drittanbieter können im Rahmen von AdSense unter Umständen Cookies
            in Ihrem Browser platzieren und auslesen bzw. Web-Beacons verwenden,
            um Daten zu speichern, die sie durch die Anzeigenbereitstellung auf
            der Webseite erhalten. Als Web-Beacons bezeichnet man kleine
            Grafiken, die eine Logdatei-Analyse und eine Aufzeichnung der
            Logdatei machen. Diese Analyse ermöglicht eine statistische
            Auswertung für das Online-Marketing.
          </p>
          <p>
            Google kann über diese Cookies bestimmte Informationen über Ihr
            Userverhalten auf unserer Webseite sammeln. Dazu zählen:
          </p>
          <p>
            -Informationen wie Sie mit einer Anzeige umgehen (Klicks,
            Impression, Mausbewegungen)
            <br />
            -Informationen, ob in Ihrem Browser schon eine Anzeige zu einem
            früheren Zeitpunkt erschienen ist. Diese Daten helfen dabei, Ihnen
            eine Anzeige nicht öfter anzuzeigen.
            <br />
          </p>
          <p>
            Dabei analysiert Google die Daten zu den angezeigten Werbemitteln
            und Ihre IP-Adresse und wertet diese aus. Google verwendet die Daten
            in erster Linie, um die Effektivität einer Anzeige zu messen und das
            Werbeangebot zu verbessern. Diese Daten werden nicht mit
            personenbezogenen Daten, die Google möglicherweise über andere
            Google-Dienste von Ihnen hat, verknüpft.
          </p>
          <p>
            Im Folgenden stellen wir Ihnen Cookies vor, die Google AdSense für
            Trackingzwecke verwendet. Hierbei beziehen wir uns auf eine
            Test-Webseite, die ausschließlich Google AdSense installiert hat:
            <strong> </strong>
          </p>
          <p>
            <strong>Name: </strong> uid
          </p>
          <p>
            <strong>Wert: </strong> 891269189311175631-8
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie wird unter der Domain
            adform.net gespeichert. Es stellt eine eindeutig zugewiesene,
            maschinell generierte User-ID bereit und sammelt Daten über die
            Aktivität auf unserer Webseite.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Monaten
          </p>
          <p>
            <strong>Name: </strong> C
          </p>
          <p>
            <strong>Wert: </strong> 1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie identifiziert, ob
            Ihrer Browser Cookies akzeptiert. Das Cookie wird unter der Domain
            track.adform.net gespeichert.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 1 Monat
          </p>
          <p>
            <strong>Name: </strong> cid
          </p>
          <p>
            <strong>Wert: </strong> 8912691894970695056,0,0,0,0
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie wird unter der
            Domain track.adform.net gespeichert, steht für Client-ID und wird
            verwendet, um die Werbung für Sie zu verbessern. Es kann relevantere
            Werbung an den Besucher weiterleiten und hilft, die Berichte über
            die Kampagnenleistung zu verbessern.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Monaten
          </p>
          <p>
            <strong>Name: </strong> IDE
          </p>
          <p>
            <strong>Wert: </strong> zOtj4TWxwbFDjaATZ2TzNaQmxrU311175631-1
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie wird unter der Domain
            doubleclick.net gespeichert. Es dient dazu, Ihre Aktionen nach der
            Anzeige bzw. nach dem Klicken der Anzeige zu registrieren. Dadurch
            kann man messen, wie gut eine Anzeige bei unseren Besuchern ankommt.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 1 Monat
          </p>
          <p>
            <strong>Name: </strong> test_cookie
          </p>
          <p>
            <strong>Wert: </strong> keine Angabe
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Mithilfe des „test_cookies“ kann
            man überprüfen, ob Ihr Browser überhaupt Cookies unterstützt. Das
            Cookie wird unter der Domain doubleclick.net gespeichert.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 1 Monat
          </p>
          <p>
            <strong>Name: </strong> CT592996
          </p>
          <p>
            <strong>Wert: </strong>733366
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Wird unter der Domain adform.net
            gespeichert. Das Cookie wird gesetzt sobald Sie auf eine
            Werbeanzeige klicken. Genauere Informationen über die Verwendung
            dieses Cookies konnten wir nicht in Erfahrung bringen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach einer Stunde
          </p>
          <p>
            <strong>Anmerkung: </strong> Diese Aufzählung kann keinen Anspruch
            auf Vollständigkeit erheben, da Google erfahrungsgemäß die Wahl
            ihrer Cookies immer wieder auch verändert.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Google erfasst Ihre IP-Adresse und verschiedene Aktivitäten, die Sie
            auf der Webseite ausführen. Cookies speichern diese Informationen zu
            den Interaktionen auf unserer Webseite. Laut Google sammelt und
            speichert das Unternehmen die angegebenen Informationen auf sichere
            Weise auf den hauseigenen Google-Servern in den USA.
          </p>
          <p>
            Wenn Sie kein Google-Konto haben bzw. nicht angemeldet sind,
            speichert Google die erhobenen Daten mit einer eindeutigen Kennung
            (ID) meist auf Ihrem Browser. Die in Cookies gespeicherten
            eindeutigen IDs dienen beispielsweise dazu, personalisierte Werbung
            zu gewährleisten. Wenn Sie in einem Google-Konto angemeldet sind,
            kann Google auch personenbezogene Daten erheben.
          </p>
          <p>
            Einige der Daten, die Google speichert, können Sie jederzeit wieder
            löschen (siehe nächsten Abschnitt). Viele Informationen, die in
            Cookies gespeichert sind, werden automatisch nach einer bestimmten
            Zeit wieder gelöscht. Es gibt allerdings auch Daten, die von Google
            über einen längeren Zeitraum gespeichert werden. Dies ist dann der
            Fall, wenn Google aus wirtschaftlichen oder rechtlichen
            Notwendigkeiten, gewisse Daten über einen unbestimmten, längeren
            Zeitraum speichern muss.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Sie haben immer die Möglichkeit Cookies, die sich auf Ihrem Computer
            befinden, zu löschen oder zu deaktivieren. Wie genau das
            funktioniert hängt von Ihrem Browser ab.
          </p>
          <p>
            Hier finden Sie die Anleitung, wie Sie Cookies in Ihrem Browser
            verwalten:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie das Cookie erlauben oder nicht. Durch das
            Herunterladen und Installieren dieses Browser-Plug-ins auf
            <a href='https://support.google.com/ads/answer/7395996'>
              https://support.google.com/ads/answer/7395996
            </a>{' '}
            werden ebenfalls alle „Werbecookies“ deaktiviert. Bedenken Sie, dass
            Sie durch das Deaktivieren dieser Cookies nicht die Werbeanzeigen
            verhindern, sondern nur die personalisierte Werbung.
          </p>
          <p>
            Wenn Sie ein Google Konto besitzen, können Sie auf der Webseite
            <a href='https://adssettings.google.com/authenticated'>
              https://adssettings.google.com/authenticated
            </a>{' '}
            personalisierte Werbung deaktivieren. Auch hier sehen Sie dann
            weiter Anzeigen, allerdings sind diese nicht mehr an Ihre Interessen
            angepasst. Dennoch werden die Anzeigen auf der Grundlage von ein
            paar Faktoren, wie Ihrem Standort, dem Browsertyp und der
            verwendeten Suchbegriffe, angezeigt.
          </p>
          <p>
            Welche Daten Google grundsätzlich erfasst und wofür sie diese Daten
            verwenden, können Sie auf
            <a href='https://www.google.com/intl/de/policies/privacy/'>
              https://www.google.com/intl/de/policies/privacy/
            </a>{' '}
            nachlesen.
          </p>
          <h2>
            <strong>
              Google Ads (Google AdWords) Conversion-Tracking
              Datenschutzerklärung
            </strong>
          </h2>
          <p>
            Wir verwenden als Online-Marketing-Maßnahme Google Ads (früher
            Google AdWords), um unsere Produkte und Dienstleistungen zu
            bewerben. So wollen wir im Internet mehr Menschen auf die hohe
            Qualität unserer Angebote aufmerksam machen. Im Rahmen unserer
            Werbe-Maßnahmen durch Google Ads verwenden wir auf unserer Website
            das Conversion-Tracking der Firma Google Inc. In Europa ist
            allerdings für alle Google-Dienste das Unternehmen Google Ireland
            Limited (Gordon House, Barrow Street Dublin 4, Irland)
            verantwortlich. Mithilfe dieses kostenlosen Tracking-Tools können
            wir unser Werbeangebot an Ihre Interessen und Bedürfnisse besser
            anpassen. Im Folgenden Artikel wollen wir genauer darauf eingehen,
            warum wir Conversion-Tracking benutzen, welche Daten dabei
            gespeichert werden und wie Sie diese Datenspeicherung verhindern.
          </p>
          <h3>
            <strong>Was ist Google Ads Conversion-Tracking?</strong>
          </h3>
          <p>
            Google Ads (früher Google AdWords) ist das hauseigene
            Online-Werbesystem der Firma Google Inc. Wir sind von der Qualität
            unseres Angebots überzeugt und wollen, dass so viele Menschen wie
            möglich unsere Webseite kennenlernen. Im Onlinebereich bietet Google
            Ads dafür die beste Plattform. Natürlich wollen wir auch einen
            genauen Überblick über den Kosten-Nutzen-Faktor unsere Werbeaktionen
            gewinnen. Darum verwenden wir das Conversion-Tracking-Tool von
            Google Ads.
          </p>
          <p>
            Doch was ist eine Conversion eigentlich? Eine Conversion entsteht,
            wenn Sie von einem rein interessierten Webseitenbesucher zu einem
            handelnden Besucher werden. Dies passiert immer dann, wenn Sie auf
            unsere Anzeige klicken und im Anschluss eine andere Aktion
            ausführen, wie zum Beispiel unsere Webseite besuchen. Mit dem
            Conversion-Tracking-Tool von Google erfassen wir, was nach einem
            Klick eines Users auf unsere Google Ads-Anzeige geschieht. Zum
            Beispiel können wir so sehen, ob Produkte gekauft werden,
            Dienstleistungen in Anspruch genommen werden oder ob sich User für
            unseren Newsletter angemeldet haben.
          </p>
          <h3>
            <strong>
              Warum verwenden wir Google Ads Conversion-Tracking auf unserer
              Webseite?
            </strong>
          </h3>
          <p>
            Wir setzen Google Ads ein, um auch auf anderen Webseiten auf unser
            Angebot aufmerksam zu machen. Ziel ist es, dass unsere
            Werbekampagnen wirklich auch nur jene Menschen erreichen, die sich
            für unsere Angebote interessieren. Mit dem Conversion-Tracking Tool
            sehen wir welche Keywords, Anzeigen, Anzeigengruppen und Kampagnen
            zu den gewünschten Kundenaktionen führen. Wir sehen wie viele Kunden
            mit unseren Anzeigen auf einem Gerät interagieren und dann eine
            Conversion durchführen. Durch diese Daten können wir unseren
            Kosten-Nutzen-Faktor berechnen, den Erfolg einzelner Werbemaßnahmen
            messen und folglich unsere Online-Marketing-Maßnahmen optimieren.
            Wir können weiters mithilfe der gewonnenen Daten unsere Webseite für
            Sie interessanter gestalten und unser Werbeangebot noch
            individueller an Ihre Bedürfnisse anpassen.
          </p>
          <h3>
            <strong>
              Welche Daten werden bei Google Ads Conversion-Tracking
              gespeichert?
            </strong>
          </h3>
          <p>
            Wir haben ein Conversion-Tracking-Tag oder Code-Snippet auf unserer
            Webseite eingebunden, um gewisse User-Aktionen besser analysieren zu
            können. Wenn Sie nun eine unserer Google Ads-Anzeigen anklicken,
            wird auf Ihrem Computer (meist im Browser) oder Mobilgerät das
            Cookie „Conversion“ von einer Google-Domain gespeichert. Cookies
            sind kleine Textdateien, die Informationen auf Ihrem Computer
            speichern.
          </p>
          <p>
            Hier die Daten der wichtigsten Cookies für das Conversion-Tracking
            von Google:
          </p>
          <p>
            <strong>Name: </strong> Conversion
          </p>
          <p>
            <strong>Wert: </strong>{' '}
            EhMI_aySuoyv4gIVled3Ch0llweVGAEgt-mr6aXd7dYlSAGQ311175631-3
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie speichert jede
            Conversion, die Sie auf unserer Seite machen, nachdem Sie über eine
            Google Ad zu uns gekommen sind.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 3 Monaten
          </p>
          <p>
            <strong>Name: </strong> _gac
          </p>
          <p>
            <strong>Wert: </strong>{' '}
            1.1558695989.EAIaIQobChMIiOmEgYO04gIVj5AYCh2CBAPrEAAYASAAEgIYQfD_BwE
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dies ist ein klassisches Google
            Analytics-Cookie und dient dem Erfassen verschiedener Handlungen auf
            unserer Webseite.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 3 Monaten
          </p>
          <p>
            <strong>Anmerkung: </strong> Das Cookie _gac scheint nur in
            Verbindung mit Google Analytics auf. Die oben angeführte Aufzählung
            hat keinen Anspruch auf Vollständigkeit, da Google für analytische
            Auswertung immer wieder auch andere Cookies verwendet.
          </p>
          <p>
            Sobald Sie eine Aktion auf unserer Webseite abschließen, erkennt
            Google das Cookie und speichert Ihre Handlung als sogenannte
            Conversion. Solange Sie auf unserer Webseite surfen und das Cookie
            noch nicht abgelaufen ist, erkennen wir und Google, dass Sie über
            unsere Google-Ads-Anzeige zu uns gefunden haben. Das Cookie wird
            ausgelesen und mit den Conversion-Daten zurück an Google Ads
            gesendet. Es ist auch möglich, dass noch andere Cookies zur Messung
            von Conversions verwendet werden. Das Conversion-Tracking von Google
            Ads kann mithilfe von Google Analytics noch verfeinert und
            verbessert werden. Bei Anzeigen, die Google an verschiedenen Orten
            im Web anzeigt, werden unter unserer Domain möglicherweise Cookies
            mit dem Namen “__gads” oder “_gac” gesetzt. Seit September 2017
            werden diverse Kampagneninformationen von analytics.js mit dem
            _gac-Cookie gespeichert. Das Cookie speichert diese Daten, sobald
            Sie eine unserer Seiten aufrufen, für die die automatische
            Tag-Kennzeichnung von Google Ads eingerichtet wurde. Im Gegensatz zu
            Cookies, die für Google-Domains gesetzt werden, kann Google diese
            Conversion-Cookies nur lesen, wenn Sie sich auf unserer Webseite
            befinden. Wir erheben und erhalten keine personenbezogenen Daten.
            Wir bekommen von Google einen Bericht mit statistischen
            Auswertungen. So erfahren wir beispielsweise die Gesamtanzahl der
            User, die unsere Anzeige angeklickt haben und wir sehen, welche
            Werbemaßnahmen gut ankamen.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            An dieser Stelle wollen wir darauf hinweisen, dass wir keinen
            Einfluss darauf haben, wie Google die erhobenen Daten
            weiterverwendet. Laut Google werden die Daten verschlüsselt und auf
            sicheren Servern gespeichert. In den meisten Fällen laufen
            Conversion-Cookies nach 30 Tagen ab und übermitteln keine
            personenbezogenen Daten. Die Cookies mit dem Namen „Conversion“ und
            „_gac“ (das in Verbindung mit Google Analytics zum Einsatz kommt)
            haben ein Ablaufdatum von 3 Monaten.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Sie haben die Möglichkeit am Conversion-Tracking von Google Ads
            nicht teilzunehmen. Wenn Sie das Cookie des Google
            Conversion-Tracking über Ihren Browser deaktivieren, blockieren Sie
            das Conversion-Tracking. In diesem Fall werden Sie in der Statistik
            des Tracking-Tools nicht berücksichtigt. Sie können die
            Cookie-Einstellungen in Ihrem Browser jederzeit verändern. Bei jedem
            Browser funktioniert dies etwas anders. Hier finden Sie die
            Anleitung, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie das Cookie erlauben oder nicht. Durch das
            Herunterladen und Installieren dieses Browser-Plug-ins auf
            <a href='https://support.google.com/ads/answer/7395996'>
              https://support.google.com/ads/answer/7395996
            </a>{' '}
            werden ebenfalls alle „Werbecookies“ deaktiviert. Bedenken Sie, dass
            Sie durch das Deaktivieren dieser Cookies nicht die Werbeanzeigen
            verhindern, sondern nur die personalisierte Werbung.
          </p>
          <p>
            Durch die Zertifizierung für das amerikanische-europäische
            Datenschutzübereinkommen “Privacy Shield”, muss der amerikanische
            Konzern Google LLC die in der EU geltenden Datenschutzgesetze
            einhalten. Wenn Sie Näheres über den Datenschutz bei Google erfahren
            möchten, empfehlen wir die allgemeine Datenschutzerklärung von
            Google:
            <a href='https://policies.google.com/privacy?hl=de'>
              https://policies.google.com/privacy?hl=de
            </a>
            .
          </p>
          <h4>
            <strong>Doubleclick</strong>
          </h4>
          <p>
            Doubleclick ist eine Dienstleistung von Google Inc., 1600
            Amphitheatre Parkway, Mountain View, CA 94043, USA ("Google").
            Doubleclick verwendet Cookies um Ihnen für Sie relevante
            Werbeanzeigen zu präsentieren. Dabei wird Ihrem Browser eine
            pseudonyme Identifikationsnummer (ID) zugeordnet, um zu überprüfen,
            welche Anzeigen in Ihrem Browser eingeblendet wurden und welche
            Anzeigen aufgerufen wurden. Die Cookies enthalten keine weiteren
            personenbezogenen Informationen. Die Verwendung der
            DoubleClick-Cookies ermöglicht Google und seinen Partner-Webseiten
            lediglich die Schaltung von Anzeigen auf Basis vorheriger Besuche
            auf unserer oder anderen Webseiten im Internet. Die durch die
            Cookies erzeugten Informationen werden von Google zur Auswertung an
            einen Server in den USA übertragen und dort gespeichert. Eine
            Übertragung der Daten durch Google an Dritte findet nur aufgrund
            gesetzlicher Vorschriften oder im Rahmen der
            Auftragsdatenverarbeitung statt. Keinesfalls wird Google ihre Daten
            mit anderen von Google erfassten Daten zusammenbringen. Durch die
            Nutzung unserer Webseiten erklären Sie sich mit der Bearbeitung der
            über Sie erhobenen Daten durch Google und der zuvor beschriebenen
            Art und Weise der Datenverarbeitung sowie dem benannten Zweck
            einverstanden. Sie können die Speicherung der Cookies durch eine
            entsprechende Einstellung Ihrer Browser-Software verhindern.
          </p>
          <p>
            Sie können darüber hinaus die Erfassung der durch die Cookies
            erzeugten und auf Ihre Nutzung der Webseiten bezogenen Daten, der
            Übermittlung sowie die Verarbeitung dieser Daten durch Google
            verhindern, indem Sie personalisierte Werbung in Ihrem Google-Konto
            deaktivieren. Folgen Sie dem Link:
          </p>
          <p>
            <a href='https://www.google.com/settings/ads/onweb/'>
              https://www.google.com/settings/ads/onweb/
            </a>
          </p>
          <p>
            Weitergehende Informationen und die Datenschutzbestimmungen finden
            Sie in der Datenschutzerklärung von Google unter:
          </p>
          <p>
            <a href='https://www.google.com/policies/technologies/ads/'>
              http://www.google.com/policies/technologies/ads/
            </a>
          </p>
          <p> </p>
          <h4>
            <strong>Bing</strong>
          </h4>
          <p>
            Wir nutzen auf unserer Internetseite das Conversion-Tracking-Tool
            „Bing Ads“. Diese wird von der Microsoft Corporation, One Microsoft
            Way, Redmond, WA 98052-6399, USA angeboten. Dabei wird von Microsoft
            Bing Ads ein Cookie auf Ihrem Rechner gesetzt, wenn Sie über eine
            Microsoft Bing Anzeige auf unsere Website gelangt sind. Diese
            Cookies verlieren nach 180 Tagen ihre Gültigkeit. Besucht der Nutzer
            bestimmte Seiten dieser Website und ist das Cookie noch nicht
            abgelaufen, können Microsoft und wir erkennen, dass der Nutzer auf
            die Anzeige geklickt hat und zu dieser Seite (Conversion-Seite)
            weitergeleitet wurde.
          </p>
          <p>
            Die mithilfe des Conversion-Cookies eingeholten Informationen dienen
            der Erfassung, wie viele Nutzer nach Anklicken einer Anzeige auf
            eine Conversion-Seite gelangen. Wir erfahren hierdurch die
            Gesamtanzahl der Nutzer, die auf unsere Anzeige geklickt haben und
            zu einer mit einem Conversion-Tracking-Tag versehenen Seite
            weitergeleitet wurden. Wir erhalten jedoch keine Informationen, mit
            denen sich Nutzer persönlich identifizieren lassen. Wenn Sie nicht
            am Tracking teilnehmen möchten, können Sie dieser Nutzung
            widersprechen, indem Sie das Cookie des Bing Ads
            Conversion-Trackings über ihren Internet-Browser unter
            Nutzereinstellungen leicht deaktivieren. Sie werden sodann nicht in
            die Conversion-Tracking Statistiken aufgenommen.
          </p>
          <p>
            Alternativ können Sie unter Nutzung der Deaktivierungsseite für
            Verbraucher aus der EU
          </p>
          <p>
            <a href='http://www.youronlinechoices.com/uk/your-ad-choices/'>
              http://www.youronlinechoices.com/uk/your-ad-choices/
            </a>
          </p>
          <p>
            überprüfen, ob Werbe-Cookies von Microsoft in Ihrem Browser gesetzt
            werden und diese deaktivieren. Unter der nachstehenden
            Internetadresse erhalten Sie weitere Informationen über die
            Datenschutzbestimmungen von Microsoft Bing Ads:
          </p>
          <p>
            <a href='https://privacy.microsoft.com/de-de/privacystatement'>
              https://privacy.microsoft.com/de-de/privacystatement
            </a>
          </p>
          <h4>
            <strong>Algolia</strong>
          </h4>
          <p>
            Auf unserer Seite nutzen wir für die Suche nach Seiteninhalten
            Algolia, einen Service der Algolia, Inc., 589 Howard Street, Suite
            5, San Francisco, CA 94105, USA. Suchanfragen werden mit sofortiger
            visueller Rückmeldung geliefert. Der Service dient der guten
            Erreichbarkeit und leichten Auffindbarkeit unserer Angebote. Um die
            Suche mit Algolia nutzen zu können, ist die Speicherung Ihrer
            Suchanfrage und der IP-Adresse Ihres Endgerätes erforderlich. Diese
            Informationen werden in der Regel an einen Server in Europa oder in
            den USA übertragen und dort gespeichert. Wir haben keinen Einfluss
            auf diese Datenübertragung. Nähere Informationen finden Sie in den
            Datenschutzhinweisen von Algolia, die Sie hier abrufen können:
          </p>
          <p>
            <a href='https://www.algolia.com/policies/privacy'>
              https://www.algolia.com/policies/privacy
            </a>
          </p>
          <p>
            <strong>Awin</strong>
          </p>
          <p>
            Awin wird von der AWIN AG, Eichhornstraße 3, 10785 Berlin,
            bereitgestellt. Du kannst der Erhebung bzw. Auswertung deiner Daten
            durch dieses Tool widersprechen, indem du das unter dem folgenden
            Link verfügbare Opt-Out Cookie herunterladen bzw. setzen und
            speichern{' '}
            <a href='https://www.awin.com/de/rechtliches/cookieoptout'>
              https://www.awin.com/de/rechtliches/cookieoptout
            </a>{' '}
            .
          </p>
          <p>
            <strong>Criteo</strong>
          </p>
          <p>
            Criteo ist auf das Erstellen und Ausliefern personalisierter Werbung
            über „Criteo Dynamic Retargeting” und „Criteo Sponsored Products“
            spezialisiert. Wir kooperieren mit Online-Partnern, um Usern, die
            die Website dieser Partner besuchen, bzw. ihre Apps nutzen, Werbung
            anzubieten. Darüber hinaus kooperieren wir mit Publishern, um
            personalisierte Werbung anzuzeigen. Unser Ziel ist es, Ihnen Werbung
            und Produkte zu zeigen, die für Sie möglichst relevant sind –
            basierend auf Ihrem aktuellen Surf- und Such-Verhalten. Beispiel für
            eine Produktanzeige mit Criteo Dynamic Retargeting: Wenn Sie
            beispielsweise Website/App A besuchen/verwenden und anschließend
            Website/App B, zeigen wir Ihnen dort personalisierte Werbung auf
            Basis Ihres Surf-/Nutzungsverhaltens in Hinblick auf Website/App A.
            Mithilfe unseres Service sollten Sie personalisierte Werbung
            erhalten, die relevanter für Sie ist als die normale Werbung, die
            Sie ohne Criteo erhalten. Mehr Informationen zu Interessen-basierter
            Werbung finden Sie hier. Die Datenschutzrichtlinien, so wie eine
            Möglichkeit zum Opt-Out bei Criteo finden Sie unter der folgenden
            Adresse:{' '}
            <a href='https://www.criteo.com/de/privacy/'>
              https://www.criteo.com/de/privacy/
            </a>
          </p>
          <h2>
            <strong>Facebook Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf unserer Webseite ausgewählte Tools von Facebook.
            Facebook ist ein Social Media Network des Unternehmens Facebook
            Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2
            Ireland. Mithilfe dieser Tools können wir Ihnen und Menschen, die
            sich für unsere Produkte und Dienstleistungen interessieren, das
            bestmögliche Angebot bieten. Im Folgenden geben wir einen Überblick
            über die verschiedenen Facebook Tools, welche Daten an Facebook
            gesendet werden und wie Sie diese Daten löschen können.
          </p>
          <h3>
            <strong>Was sind Facebook-Tools?</strong>
          </h3>
          <p>
            Neben vielen anderen Produkten bietet Facebook auch die sogenannten
            “Facebook Business Tools” an. Das ist die offizielle Bezeichnung von
            Facebook. Da der Begriff aber kaum bekannt ist, haben wir uns dafür
            entschieden, sie lediglich Facebook-Tools zu nennen. Darunter finden
            sich unter anderem:
          </p>
          <p>
            -Facebook-Pixel
            <br />
            -soziale Plug-ins (wie z.B der „Gefällt mir“- oder „Teilen“-Button)
            <br />
            -Facebook Login
            <br />
            -Account Kit
            <br />
            -APIs (Programmierschnittstelle)
            <br />
            -SDKs (Sammlung von Programmierwerkzeugen)
            <br />
            -Plattform-Integrationen
            <br />
            -Plugins
            <br />
            -Codes
            <br />
            -Spezifikationen
            <br />
            -Dokumentationen
            <br />
            -Technologien und Dienstleistungen
            <br />
          </p>
          <p>
            Durch diese Tools erweitert Facebook Dienstleistungen und hat die
            Möglichkeit, Informationen über User-Aktivitäten außerhalb von
            Facebook zu erhalten.
          </p>
          <p>
            <strong>Facebook Germany</strong>
          </p>
          <p>
            Facebook Germany wird von der Facebook Germany, Caffamacherreihe 7,
            20355 Hamburg, bereitgestellt. Du kannst der Erhebung bzw.
            Auswertung deiner Daten durch dieses Tool widersprechen, indem Sie
            das unter dem folgenden Link verfügbare Opt-Out Cookie herunterladen
            bzw. setzen und speichern:{' '}
            <a href='https://www.facebook.com/help/568137493302217'>
              https://www.facebook.com/help/568137493302217
            </a>
          </p>
          <h3>
            <strong>
              Warum verwenden wir Facebook-Tools auf unserer Webseite?
            </strong>
          </h3>
          <p>
            Wir wollen unsere Dienstleistungen und Produkte nur Menschen zeigen,
            die sich auch wirklich dafür interessieren. Mithilfe von
            Werbeanzeigen (Facebook-Ads) können wir genau diese Menschen
            erreichen. Damit den Usern passende Werbung gezeigt werden kann,
            benötigt Facebook allerdings Informationen über die Wünsche und
            Bedürfnisse der Menschen. So werden dem Unternehmen Informationen
            über das Userverhalten (und Kontaktdaten) auf unserer Webseite zur
            Verfügung gestellt. Dadurch sammelt Facebook bessere User-Daten und
            kann interessierten Menschen die passende Werbung über unsere
            Produkte bzw. Dienstleistungen anzeigen. Die Tools ermöglichen somit
            maßgeschneiderte Werbekampagnen auf Facebook.
          </p>
          <p>
            Daten über Ihr Verhalten auf unserer Webseite nennt Facebook
            „Event-Daten“. Diese werden auch für Messungs- und Analysedienste
            verwendet. Facebook kann so in unserem Auftrag „Kampagnenberichte“
            über die Wirkung unserer Werbekampagnen erstellen. Weiters bekommen
            wir durch Analysen einen besseren Einblick, wie Sie unsere
            Dienstleistungen, Webseite oder Produkte verwenden. Dadurch
            optimieren wir mit einigen dieser Tools Ihre Nutzererfahrung auf
            unserer Webseite. Beispielsweise können Sie mit den sozialen
            Plug-ins Inhalte auf unserer Seite direkt auf Facebook teilen.
          </p>
          <h3>
            <strong>Welche Daten werden von Facebook-Tools gespeichert?</strong>
          </h3>
          <p>
            Durch die Nutzung einzelner Facebook-Tools können personenbezogene
            Daten (Kundendaten) an Facebook gesendet werden. Abhängig von den
            benutzten Tools können Kundendaten wie Name, Adresse, Telefonnummer
            und IP-Adresse versandt werden.
          </p>
          <p>
            Facebook verwendet diese Informationen, um die Daten mit den Daten,
            die es selbst von Ihnen hat (sofern Sie Facebook-Mitglied sind)
            abzugleichen. Bevor Kundendaten an Facebook übermittelt werden,
            erfolgt ein sogenanntes „Hashing“. Das bedeutet, dass ein beliebig
            großer Datensatz in eine Zeichenkette transformiert wird. Dies dient
            auch der Verschlüsselung von Daten.
          </p>
          <p>
            Neben den Kontaktdaten werden auch „Event-Daten“ übermittelt. Unter
            „Event-Daten“ sind jene Informationen gemeint, die wir über Sie auf
            unserer Webseite erhalten. Zum Beispiel, welche Unterseiten Sie
            besuchen oder welche Produkte Sie bei uns kaufen. Facebook teilt die
            erhaltenen Informationen nicht mit Drittanbietern (wie
            beispielsweise Werbetreibende), außer das Unternehmen hat eine
            explizite Genehmigung oder ist rechtlich dazu verpflichtet.
            „Event-Daten“ können auch mit Kontaktdaten verbunden werden. Dadurch
            kann Facebook bessere personalisierte Werbung anbieten. Nach dem
            bereits erwähnten Abgleichungsprozess löscht Facebook die
            Kontaktdaten wieder.
          </p>
          <p>
            Um Werbeanzeigen optimiert ausliefern zu können, verwendet Facebook
            die Event-Daten nur, wenn diese mit anderen Daten (die auf andere
            Weise von Facebook erfasst wurden) zusammengefasst wurden. Diese
            Event-Daten nützt Facebook auch für Sicherheits-, Schutz-,
            Entwicklungs- und Forschungszwecken. Viele dieser Daten werden über
            Cookies zu Facebook übertragen. Cookies sind kleine Text-Dateien,
            die zum Speichern von Daten bzw. Informationen in Browsern verwendet
            werden. Je nach verwendeten Tools und abhängig, ob Sie
            Facebook-Mitglied sind, werden unterschiedlich viele Cookies in
            Ihrem Browser angelegt. In den Beschreibungen der einzelnen Facebook
            Tools gehen wir näher auf einzelne Facebook-Cookies ein. Allgemeine
            Informationen über die Verwendung von Facebook-Cookies erfahren Sie
            auch auf
            <a href='https://www.facebook.com/policies/cookies?tid=311175631'>
              https://www.facebook.com/policies/cookies
            </a>
            .
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Grundsätzlich speichert Facebook Daten bis sie nicht mehr für die
            eigenen Dienste und Facebook-Produkte benötigt werden. Facebook hat
            auf der ganzen Welt Server verteilt, wo Ihre Daten gespeichert
            werden. Kundendaten werden allerdings, nachdem sie mit den eigenen
            Userdaten abgeglichen wurden, innerhalb von 48 Stunden gelöscht.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Entsprechend der Datenschutz Grundverordnung haben Sie das Recht auf
            Auskunft, Berichtigung, Übertragbarkeit und Löschung Ihrer Daten.
          </p>
          <p>
            Eine komplette Löschung der Daten erfolgt nur, wenn Sie Ihr
            Facebook-Konto vollständig löschen. Und so funktioniert das Löschen
            Ihres Facebook-Kontos:
          </p>
          <p>1) Klicken Sie rechts bei Facebook auf Einstellungen.</p>
          <p>
            2) Anschließend klicken Sie in der linken Spalte auf „Deine
            Facebook-Informationen“.
          </p>
          <p>3) Nun klicken Sie “Deaktivierung und Löschung”.</p>
          <p>
            4) Wählen Sie jetzt „Konto löschen“ und klicken Sie dann auf „Weiter
            und Konto löschen“
          </p>
          <p>
            5) Geben Sie nun Ihr Passwort ein, klicken Sie auf „Weiter“ und dann
            auf „Konto löschen“
          </p>
          <p>
            Die Speicherung der Daten, die Facebook über unsere Seite erhält,
            erfolgt unter anderem über Cookies (z.B. bei sozialen Plugins). In
            Ihrem Browser können Sie einzelne oder alle Cookies deaktivieren,
            löschen oder verwalten. Je nach dem welchen Browser Sie verwenden,
            funktioniert dies auf unterschiedliche Art und Weise. Die folgenden
            Anleitungen zeigen, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie es erlauben oder nicht.
          </p>
          <p>
            Facebook ist aktiver Teilnehmer beim EU-U.S. Privacy Shield
            Framework, wodurch der korrekte und sichere Datentransfer
            persönlicher Daten geregelt wird. Mehr Informationen dazu finden Sie
            auf
            <a href='https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC'>
              https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC
            </a>
            . Wir hoffen wir haben Ihnen die wichtigsten Informationen über die
            Nutzung und Datenverarbeitung durch die Facebook-Tools
            nähergebracht. Wenn Sie mehr darüber erfahren wollen, wie Facebook
            Ihre Daten verwendet, empfehlen wir Ihnen die Datenrichtlinien auf
            <a href='https://www.facebook.com/about/privacy/update'>
              https://www.facebook.com/about/privacy/update
            </a>
            .
          </p>
          <h2>
            <strong>Facebook Soziale Plug-ins Datenschutzerklärung</strong>
          </h2>
          <p>
            Auf unserer Webseite sind sogenannte soziale Plug-ins des
            Unternehmens Facebook Inc. eingebaut. Sie erkennen diese Buttons am
            klassischen Facebook-Logo, wie dem „Gefällt mir“-Button (die Hand
            mit erhobenem Daumen) oder an einer eindeutigen „Facebook
            Plug-in“-Kennzeichnung. Ein soziales Plug-in ist ein kleiner Teil
            von Facebook, der in unsere Seite integriert ist. Jedes Plug-in hat
            eine eigene Funktion. Die am meisten verwendeten Funktionen sind die
            bekannten “Gefällt mir”- und “Teilen”-Buttons.
          </p>
          <p>Folgende soziale Plug-ins werden von Facebook angeboten:</p>
          <p>
            -“Speichern”-Button
            <br />
            -“Gefällt mir”-Button, Teilen, Senden und Zitat
            <br />
            -Seiten-Plug-in
            <br />
            -Kommentare
            <br />
            -Messenger-Plug-in
            <br />
            -Eingebettete Beiträge und Videoplayer
            <br />
            -Gruppen-Plug-in
            <br />
          </p>
          <p>
            Auf
            <a href='https://developers.facebook.com/docs/plugins'>
              https://developers.facebook.com/docs/plugins
            </a>{' '}
            erhalten Sie nähere Informationen, wie die einzelnen Plug-ins
            verwendet werden. Wir nützen die sozialen Plug-ins einerseits, um
            Ihnen ein besseres Usererlebnis auf unserer Seite zu bieten,
            andererseits weil Facebook dadurch unsere Werbeanzeigen optimieren
            kann.
          </p>
          <p>
            Sofern Sie ein Facebook-Konto haben oder
            <a href='https://www.facebook.com/'>facebook.com</a> schon mal
            besucht haben, hat Facebook bereits mindestens ein Cookie in Ihrem
            Browser gesetzt. In diesem Fall sendet Ihr Browser über dieses
            Cookie Informationen an Facebook, sobald Sie unsere Seite besuchen
            bzw. mit sozialen Plug-ins (z.B. dem „Gefällt mir“-Button)
            interagieren.
          </p>
          <p>
            Die erhaltenen Informationen werden innerhalb von 90 Tagen wieder
            gelöscht bzw. anonymisiert. Laut Facebook gehören zu diesen Daten
            Ihre IP-Adresse, welche Webseite Sie besucht haben, das Datum, die
            Uhrzeit und weitere Informationen, die Ihren Browser betreffen.
          </p>
          <p>
            Um zu verhindern, dass Facebook während Ihres Besuches auf unserer
            Webseite viele Daten sammelt und mit den Facebook-Daten verbindet,
            müssen Sie sich während des Webseitenbesuchs von Facebook abmelden
            (ausloggen).
          </p>
          <p>
            Falls Sie bei Facebook nicht angemeldet sind oder kein
            Facebook-Konto besitzen, sendet Ihr Browser weniger Informationen an
            Facebook, weil Sie weniger Facebook-Cookies haben. Dennoch können
            Daten wie beispielsweise Ihre IP-Adresse oder welche Webseite Sie
            besuchen an Facebook übertragen werden. Wir möchten noch
            ausdrücklich darauf hinweisen, dass wir über die genauen Inhalte der
            Daten nicht exakt Bescheid wissen. Wir versuchen aber Sie nach
            unserem aktuellen Kenntnisstand so gut als möglich über die
            Datenverarbeitung aufzuklären. Wie Facebook die Daten nutzt, können
            Sie auch in den Datenrichtline des Unternehmens unter
            <a href='https://www.facebook.com/about/privacy/update'>
              https://www.facebook.com/about/privacy/update
            </a>{' '}
            nachlesen.
          </p>
          <p>
            Folgende Cookies werden in Ihrem Browser mindestens gesetzt, wenn
            Sie eine Webseite mit sozialen Plug-ins von Facebook besuchen:
          </p>
          <p>
            <strong>Name: </strong> dpr
          </p>
          <p>
            <strong>Wert: </strong> keine Angabe
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie wird verwendet,
            damit die sozialen Plug-ins auf unserer Webseite funktionieren.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Sitzungsende
          </p>
          <p>
            <strong>Name: </strong> fr
          </p>
          <p>
            <strong>Wert: </strong>{' '}
            0jieyh4311175631c2GnlufEJ9..Bde09j…1.0.Bde09j
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Auch das Cookie ist nötig, dass
            die Plug-ins einwandfrei funktionieren.
          </p>
          <p>
            <strong>Ablaufdatum:: </strong> nach 3 Monaten
          </p>
          <p>
            <strong>Anmerkung: </strong> Diese Cookies wurden nach einem Test
            gesetzt, auch wenn Sie nicht Facebook-Mitglied sind.
          </p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre
            Einstellungen für Werbeanzeigen unter
            <a href='https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen'>
              https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
            </a>{' '}
            selbst verändern. Falls Sie kein Facebook-User sind, können Sie auf
            <a href='http://www.youronlinechoices.com/de/praferenzmanagement/?tid=311175631'>
              http://www.youronlinechoices.com/de/praferenzmanagement/
            </a>
            grundsätzlich Ihre nutzungsbasierte Online-Werbung verwalten. Dort
            haben Sie die Möglichkeit, Anbieter zu deaktivieren bzw. zu
            aktivieren.
          </p>
          <p>
            Wenn Sie mehr über den Datenschutz von Facebook erfahren wollen,
            empfehlen wir Ihnen die eigenen Datenrichtlinien des Unternehmens
            auf
            <a href='https://www.facebook.com/policy.php?tip=311175631'>
              https://www.facebook.com/policy.php
            </a>
            .
          </p>
          <h2>
            <strong>Facebook Login Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir haben auf unserer Seite das praktische Facebook Login
            integriert. So können Sie sich bei uns ganz einfach mit Ihrem
            Facebook-Konto einloggen, ohne ein weiteres Benutzerkonto anlegen zu
            müssen. Wenn Sie sich entscheiden, Ihre Registrierung über das
            Facebook Login zu machen, werden Sie auf das Social Media Network
            Facebook weitergeleitet. Dort erfolgt die Anmeldung über Ihre
            Facebook Nutzerdaten. Durch dieses Login-Verfahren werden Daten über
            Sie bzw. Ihr Userverhalten gespeichert und an Facebook übermittelt.
          </p>
          <p>
            Um die Daten zu speichern, benutzt Facebook verschiedene Cookies. Im
            Folgenden zeigen wir Ihnen die wichtigsten Cookies, die in Ihrem
            Browser gesetzt werden bzw. schon bestehen, wenn Sie sich über das
            Facebook Login auf unserer Seite anmelden:
          </p>
          <p>
            <strong>Name: </strong> fr
          </p>
          <p>
            <strong>Wert: </strong> 0jieyh4c2GnlufEJ9..Bde09j…1.0.Bde09j
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie wird verwendet,
            damit das soziale Plugin auf unserer Webseite bestmöglich
            funktioniert.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 3 Monaten
          </p>
          <p>
            <strong>Name: </strong> datr
          </p>
          <p>
            <strong>Wert: </strong> 4Jh7XUA2311175631SEmPsSfzCOO4JFFl
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Facebook setzt das
            “datr”-Cookie, wenn ein Webbrowser auf facebook.com zugreift, und
            das Cookie hilft, Anmeldeaktivitäten zu identifizieren und die
            Benutzer zu schützen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Jahren
          </p>
          <p>
            <strong>Name: </strong> _js_datr
          </p>
          <p>
            <strong>Wert: </strong> deleted
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Session-Cookie setzt
            Facebook zu Trackingzwecken, auch wenn Sie kein Facebook-Konto haben
            oder ausgeloggt sind.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Sitzungsende
          </p>
          <p>
            <strong>Anmerkung: </strong> Die angeführten Cookies sind nur eine
            kleine Auswahl der Cookies, die Facebook zur Verfügung stehen.
            Weitere Cookies sind beispielsweise _ fbp, sb oder wd. Eine
            vollständige Aufzählung ist nicht möglich, da Facebook über eine
            Vielzahl an Cookies verfügt und diese variabel einsetzt.
          </p>
          <p>
            Der Facebook Login bietet Ihnen einerseits einen schnellen und
            einfachen Registrierungsprozess, andererseits haben wir so die
            Möglichkeit Daten mit Facebook zu teilen. Dadurch können wir unser
            Angebot und unsere Werbeaktionen besser an Ihre Interessen und
            Bedürfnisse anpassen. Daten, die wir auf diese Weise von Facebook
            erhalten, sind öffentliche Daten wie
          </p>
          <p>
            -Ihr Facebook-Name
            <br />
            -Ihr Profilbild
            <br />
            -eine hinterlegte E-Mail-Adresse
            <br />
            -Freundeslisten
            <br />
            -Buttons-Angaben (z.B. „Gefällt mir“-Button)
            <br />
            -Geburtstagsdatum
            <br />
            -Sprache
            <br />
            -Wohnort
            <br />
          </p>
          <p>
            Im Gegenzug stellen wir Facebook Informationen über Ihre Aktivitäten
            auf unserer Webseite bereit. Das sind unter anderem Informationen
            über Ihr verwendetes Endgerät, welche Unterseiten Sie bei uns
            besuchen oder welche Produkte Sie bei uns erworben haben.
          </p>
          <p>
            Durch die Verwendung von Facebook Login willigen Sie der
            Datenverarbeitung ein. Sie können diese Vereinbarung jederzeit
            widerrufen. Wenn Sie mehr Informationen über die Datenverarbeitung
            durch Facebook erfahren wollen, empfehlen wir Ihnen die
            Facebook-Datenschutzerklärung unter
            <a href='https://de-de.facebook.com/policy.php?tid=311175631'>
              https://de-de.facebook.com/policy.php
            </a>
            .
          </p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre
            Einstellungen für Werbeanzeigen unter
            <a href='https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen'>
              https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
            </a>{' '}
            selbst verändern.
          </p>
          <h2>
            <strong>Instagram Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir haben auf unserer Webseite Funktionen von Instagram eingebaut.
            Instagram ist eine Social Media Plattform des Unternehmens Instagram
            LLC, 1601 Willow Rd, Menlo Park CA 94025, USA. Instagram ist seit
            2012 ein Tochterunternehmen von Facebook Inc. und gehört zu den
            Facebook-Produkten. Das Einbetten von Instagram-Inhalten auf unserer
            Webseite nennt man Embedding. Dadurch können wir Ihnen Inhalte wie
            Buttons, Fotos oder Videos von Instagram direkt auf unserer Webseite
            zeigen. Wenn Sie Webseiten unserer Webpräsenz aufrufen, die eine
            Instagram-Funktion integriert haben, werden Daten an Instagram
            übermittelt, gespeichert und verarbeitet. Instagram verwendet
            dieselben Systeme und Technologien wie Facebook. Ihre Daten werden
            somit über alle Facebook-Firmen hinweg verarbeitet.
          </p>
          <p>
            Im Folgenden wollen wir Ihnen einen genaueren Einblick geben, warum
            Instagram Daten sammelt, um welche Daten es sich handelt und wie Sie
            die Datenverarbeitung weitgehend kontrollieren können. Da Instagram
            zu Facebook Inc. gehört, beziehen wir unsere Informationen
            einerseits von den Instagram-Richtlinien, andererseits allerdings
            auch von den Facebook-Datenrichtlinien selbst.
          </p>
          <h3>
            <strong>Was ist Instagram?</strong>
          </h3>
          <p>
            Instagram ist eines der bekanntesten Social Media Netzwerken
            weltweit. Instagram kombiniert die Vorteile eines Blogs mit den
            Vorteilen von audiovisuellen Plattformen wie YouTube oder Vimeo. Sie
            können auf „Insta“ (wie viele der User die Plattform salopp nennen)
            Fotos und kurze Videos hochladen, mit verschiedenen Filtern
            bearbeiten und auch in anderen sozialen Netzwerken verbreiten. Und
            wenn Sie selbst nicht aktiv sein wollen, können Sie auch nur anderen
            interessante Users folgen.
          </p>
          <h3>
            <strong>Warum verwenden wir Instagram auf unserer Webseite?</strong>
          </h3>
          <p>
            Instagram ist jene Social Media Plattform, die in den letzten Jahren
            so richtig durch die Decke ging. Und natürlich haben auch wir auf
            diesen Boom reagiert. Wir wollen, dass Sie sich auf unserer Webseite
            so wohl wie möglich fühlen. Darum ist für uns eine
            abwechslungsreiche Aufbereitung unserer Inhalte selbstverständlich.
            Durch die eingebetteten Instagram-Funktionen können wir unseren
            Content mit hilfreichen, lustigen oder spannenden Inhalten aus der
            Instagram-Welt bereichern. Da Instagram eine Tochtergesellschaft von
            Facebook ist, können uns die erhobenen Daten auch für
            personalisierte Werbung auf Facebook dienlich sein. So bekommen
            unsere Werbeanzeigen nur Menschen, die sich wirklich für unsere
            Produkte oder Dienstleistungen interessieren.
          </p>
          <p>
            Instagram nützt die gesammelten Daten auch zu Messungs- und
            Analysezwecken. Wir bekommen zusammengefasste Statistiken und so
            mehr Einblick über Ihre Wünsche und Interessen. Wichtig ist zu
            erwähnen, dass diese Berichte Sie nicht persönlich identifizieren.
          </p>
          <h3>
            <strong>Welche Daten werden von Instagram gespeichert?</strong>
          </h3>
          <p>
            Wenn Sie auf eine unserer Seiten stoßen, die Instagram-Funktionen
            (wie Instagrambilder oder Plug-ins) eingebaut haben, setzt sich Ihr
            Browser automatisch mit den Servern von Instagram in Verbindung.
            Dabei werden Daten an Instagram versandt, gespeichert und
            verarbeitet. Und zwar unabhängig, ob Sie ein Instagram-Konto haben
            oder nicht. Dazu zählen Informationen über unserer Webseite, über
            Ihren Computer, über getätigte Käufe, über Werbeanzeigen, die Sie
            sehen und wie Sie unser Angebot nutzen. Weiters werden auch Datum
            und Uhrzeit Ihrer Interaktion mit Instagram gespeichert. Wenn Sie
            ein Instagram-Konto haben bzw. eingeloggt sind, speichert Instagram
            deutlich mehr Daten über Sie.
          </p>
          <p>
            Facebook unterscheidet zwischen Kundendaten und Eventdaten. Wir
            gehen davon aus, dass dies bei Instagram genau so der Fall ist.
            Kundendaten sind zum Beispiel Name, Adresse, Telefonnummer und
            IP-Adresse. Wichtig zu erwähnen ist, dass diese Kundendaten erst an
            Instagram übermittelt werden, wenn Sie zuvor „gehasht“ wurden.
            Hashing meint, ein Datensatz wird in eine Zeichenkette verwandelt.
            Dadurch kann man die Kontaktdaten verschlüsseln. Zudem werden auch
            die oben genannten „Event-Daten“ übermittelt. Unter „Event-Daten“
            versteht Facebook – und folglich auch Instagram – Daten über Ihr
            Userverhalten. Es kann auch vorkommen, dass Kontaktdaten mit
            Event-Daten kombiniert werden. Die erhobenen Kontaktdaten werden mit
            den Daten, die Instagram bereits von Ihnen hat abgeglichen.
          </p>
          <p>
            Über kleine Text-Dateien (Cookies), die meist in Ihrem Browser
            gesetzt werden, werden die gesammelten Daten an Facebook
            übermittelt. Je nach verwendeten Instagram-Funktionen und ob Sie
            selbst ein Instagram-Konto haben, werden unterschiedlich viele Daten
            gespeichert.
          </p>
          <p>
            Wir gehen davon aus, dass bei Instagram die Datenverarbeitung gleich
            funktioniert wie bei Facebook. Das bedeutet: wenn Sie ein
            Instagram-Konto haben oder
            <a href='http://www.instagram.com?tid=311175631'>
              www.instagram.com
            </a>{' '}
            besucht haben, hat Instagram zumindest ein Cookie gesetzt. Wenn das
            der Fall ist, sendet Ihr Browser über das Cookie Infos an Instagram,
            sobald Sie mit einer Instagram-Funktion in Berührung kommen.
            Spätestens nach 90 Tagen (nach Abgleichung) werden diese Daten
            wieder gelöscht bzw. anonymisiert. Obwohl wir uns intensiv mit der
            Datenverarbeitung von Instagram beschäftigt haben, können wir nicht
            ganz genau sagen, welche Daten Instagram exakt sammelt und
            speichert.
          </p>
          <p>
            Im Folgenden zeigen wir Ihnen Cookies, die in Ihrem Browser
            mindestens gesetzt werden, wenn Sie auf eine Instagram-Funktion (wie
            z.B. Button oder ein Insta-Bild) klicken. Bei unserem Test gehen wir
            davon aus, dass Sie kein Instagram-Konto haben. Wenn Sie bei
            Instagram eingeloggt sind, werden natürlich deutlich mehr Cookies in
            Ihrem Browser gesetzt.
          </p>
          <p>Diese Cookies wurden bei unserem Test verwendet:</p>
          <p>
            <strong>Name: </strong>csrftoken
          </p>
          <p>
            <strong>Wert: </strong>“”
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie wird mit hoher
            Wahrscheinlichkeit aus Sicherheitsgründen gesetzt, um Fälschungen
            von Anfragen zu verhindern. Genauer konnten wir das allerdings nicht
            in Erfahrung bringen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach einem Jahr
          </p>
          <p>
            <strong>Name: </strong>mid
          </p>
          <p>
            <strong>Wert: </strong>“”
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Instagram setzt dieses Cookie, um
            die eigenen Dienstleistungen und Angebote in und außerhalb von
            Instagram zu optimieren. Das Cookie legt eine eindeutige User-ID
            fest.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Ende der Sitzung
          </p>
          <p>
            <strong>Name: </strong> fbsr_311175631124024
          </p>
          <p>
            <strong>Wert: </strong>keine Angaben
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie speichert die
            Log-in-Anfrage für User der Instagram-App.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Ende der Sitzung
          </p>
          <p>
            <strong>Name: </strong> rur
          </p>
          <p>
            <strong>Wert: </strong>ATN
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dabei handelt es sich um ein
            Instagram-Cookie, das die Funktionalität auf Instagram
            gewährleistet.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Ende der Sitzung
          </p>
          <p>
            <strong>Name: </strong> urlgen
          </p>
          <p>
            <strong>Wert: </strong> 194.96.75.33: 1901:
            1iEtYv:Y833k2_UjKvXgYe311175631
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie dient den
            Marketingzwecken von Instagram.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach Ende der Sitzung
          </p>
          <p>
            <strong>Anmerkung: </strong> Wir können hier keinen
            Vollständigkeitsanspruch erheben. Welche Cookies im individuellen
            Fall gesetzt werden, hängt von den eingebetteten Funktionen und
            Ihrer Verwendung von Instagram ab.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Instagram teilt die erhaltenen Informationen zwischen den
            Facebook-Unternehmen mit externen Partnern und mit Personen, mit
            denen Sie sich weltweit verbinden. Die Datenverarbeitung erfolgt
            unter Einhaltung der eigenen Datenrichtlinie. Ihre Daten sind, unter
            anderem aus Sicherheitsgründen, auf den Facebook-Servern auf der
            ganzen Welt verteilt. Die meisten dieser Server stehen in den USA.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Dank der Datenschutz Grundverordnung haben Sie das Recht auf
            Auskunft, Übertragbarkeit, Berichtigung und Löschung Ihrer Daten. In
            den Instagram-Einstellungen können Sie Ihre Daten verwalten. Wenn
            Sie Ihre Daten auf Instagram völlig löschen wollen, müssen Sie Ihr
            Instagram-Konto dauerhaft löschen.
          </p>
          <p>Und so funktioniert die Löschung des Instagram-Kontos:</p>
          <p>
            Öffnen Sie zuerst die Instagram-App. Auf Ihrer Profilseite gehen Sie
            nach unten und klicken Sie auf „Hilfebereich“. Jetzt kommen Sie auf
            die Webseite des Unternehmens. Klicken Sie auf der Webseite auf
            „Verwalten des Kontos“ und dann auf „Dein Konto löschen“.
          </p>
          <p>
            Wenn Sie Ihr Konto ganz löschen, löscht Instagram Posts wie
            beispielsweise Ihre Fotos und Status-Updates. Informationen, die
            andere Personen über Sie geteilt haben, gehören nicht zu Ihrem Konto
            und werden folglich nicht gelöscht.
          </p>
          <p>
            Wie bereits oben erwähnt, speichert Instagram Ihre Daten in erster
            Linie über Cookies. Diese Cookies können Sie in Ihrem Browser
            verwalten, deaktivieren oder löschen. Abhängig von Ihrem Browser
            funktioniert die Verwaltung immer ein bisschen anders. Hier zeigen
            wir Ihnen die Anleitungen der wichtigsten Browser.
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Sie können auch grundsätzlich Ihren Browser so einrichten, dass Sie
            immer informiert werden, wenn ein Cookie gesetzt werden soll. Dann
            können Sie immer individuell entscheiden, ob Sie das Cookie zulassen
            wollen oder nicht.
          </p>
          <p>
            Instagram ist ein Tochterunternehmen von Facebook Inc. und Facebook
            ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework. Dieses
            Framework stellt eine korrekte Datenübertragung zwischen den USA und
            der Europäischen Union sicher. Unter{' '}
            <a href='https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC'>
              https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC{' '}
            </a>
             erfahren Sie mehr darüber. Wir haben versucht, Ihnen die
            wichtigsten Informationen über die Datenverarbeitung durch Instagram
            näherzubringen. Auf
            <a href='https://help.instagram.com/519522125107875'>
              https://help.instagram.com/519522125107875
            </a>
          </p>
          <p>
            können Sie sich noch näher mit den Datenrichtlinien von Instagram
            auseinandersetzen.
          </p>
          <h2>
            <strong>
              Benutzerdefinierte Google Suche Datenschutzerklärung
            </strong>
          </h2>
          <p>
            Wir haben auf unserer Website das Google-Plug-in zur
            benutzerdefinierten Suche eingebunden. Google ist die größte und
            bekannteste Suchmaschine weltweit und wird von dem US-amerikanische
            Unternehmen Google Inc. betrieben. Für den europäischen Raum ist das
            Unternehmen Google Ireland Limited (Gordon House, Barrow Street
            Dublin 4, Irland) verantwortlich. Durch die benutzerdefinierte
            Google Suche können Daten von Ihnen an Google übertragen werden. In
            dieser Datenschutzerklärung informieren wir Sie, warum wir dieses
            Plug-in verwenden, welche Daten verarbeitet werden und wie Sie diese
            Datenübertragung verwalten oder unterbinden können.
          </p>
          <h3>
            <strong>Was ist die benutzerdefinierte Google Suche?</strong>
          </h3>
          <p>
            Das Plug-in zur benutzerdefinierten Google Suche ist eine
            Google-Suchleiste direkt auf unserer Website. Die Suche findet wie
            auf<a href='https://www.google.com?tid=311175631'>www.google.com</a>{' '}
            statt, nur fokussieren sich die Suchergebnisse auf unsere Inhalte
            und Produkte bzw. auf einen eingeschränkten Suchkreis.
          </p>
          <h3>
            <strong>
              Warum verwenden wir die benutzerdefinierte Google Suche auf
              unserer Webseite?
            </strong>
          </h3>
          <p>
            Eine Website mit vielen interessanten Inhalten wird oft so groß,
            dass man unter Umständen den Überblick verliert. Über die Zeit hat
            sich auch bei uns viel wertvolles Material angesammelt und wir
            wollen als Teil unserer Dienstleistung, dass Sie unsere Inhalte so
            schnell und einfach wie möglich finden. Durch die benutzerdefinierte
            Google-Suche wird das Finden von interessanten Inhalten zu einem
            Kinderspiel. Das eingebaute Google-Plug-in verbessert insgesamt die
            Qualität unserer Website und macht Ihnen das Suchen leichter.
          </p>
          <h3>
            <strong>
              Welche Daten werden durch die benutzerdefinierte Google Suche
              gespeichert?
            </strong>
          </h3>
          <p>
            Durch die benutzerdefinierte Google-Suche werden nur Daten von Ihnen
            an Google übertragen, wenn Sie die auf unserer Website eingebaute
            Google-Suche aktiv verwenden. Das heißt, erst wenn Sie einen
            Suchbegriff in die Suchleiste eingeben und dann diesen Begriff
            bestätigen (z.B. auf „Enter“ klicken) wird neben dem Suchbegriff
            auch Ihre IP-Adresse an Google gesandt, gespeichert und dort
            verarbeitet. Anhand der gesetzten Cookies (wie z.B. 1P_JAR) ist
            davon auszugehen, dass Google auch Daten zur Webseiten-Nutzung
            erhält. Wenn Sie während Ihrem Besuch auf unserer Webseite, über die
            eingebaute Google-Suchfunktion, Inhalte suchen und gleichzeitig mit
            Ihrem Google-Konto angemeldet sind, kann Google die erhobenen Daten
            auch Ihrem Google-Konto zuordnen. Als Websitebetreiber haben wir
            keinen Einfluss darauf, was Google mit den erhobenen Daten macht
            bzw. wie Google die Daten verarbeitet.
          </p>
          <p>
            Folgende Cookie werden in Ihrem Browser gesetzt, wenn Sie die
            benutzerdefinierte Google Suche verwenden und nicht mit einem
            Google-Konto angemeldet sind:
          </p>
          <p>
            <strong>Name: </strong> 1P_JAR
          </p>
          <p>
            <strong>Wert: </strong> 2020-01-27-13311175631-5
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Dieses Cookie sammelt
            Statistiken zur Website-Nutzung und misst Conversions. Eine
            Conversion entsteht zum Beispiel, wenn ein User zu einem Käufer
            wird. Das Cookie wird auch verwendet, um Usern relevante
            Werbeanzeigen einzublenden.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach einem Monat
          </p>
          <p>
            <strong>Name: </strong> CONSENT
          </p>
          <p>
            <strong>Wert: </strong> WP.282f52311175631-9
          </p>
          <p>
            <strong>Verwendungszweck: </strong> Das Cookie speichert den Status
            der Zustimmung eines Users zur Nutzung unterschiedlicher Services
            von Google. CONSENT dient auch der Sicherheit, um User zu überprüfen
            und Userdaten vor unbefugten Angriffen zu schützen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 18 Jahren
          </p>
          <p>
            <strong>Name: </strong> NID
          </p>
          <p>
            <strong>Wert: </strong> 196=pwIo3B5fHr-8
          </p>
          <p>
            <strong>Verwendungszweck: </strong> NID wird von Google verwendet,
            um Werbeanzeigen an Ihre Google-Suche anzupassen. Mit Hilfe des
            Cookies „erinnert“ sich Google an Ihre eingegebenen Suchanfragen
            oder Ihre frühere Interaktion mit Anzeigen. So bekommen Sie immer
            maßgeschneiderte Werbeanzeigen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 6 Monaten
          </p>
          <p>
            <strong>Anmerkung: </strong> Diese Aufzählung kann keinen Anspruch
            auf Vollständigkeit erheben, da Google die Wahl ihrer Cookies immer
            wieder auch verändert.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Die Google-Server sind auf der ganzen Welt verteilt. Da es sich bei
            Google um ein amerikanisches Unternehmen handelt, werden die meisten
            Daten auf amerikanischen Servern gespeichert. Unter{' '}
            <a href='https://www.google.com/about/datacenters/inside/locations/?hl=de'>
              https://www.google.com/about/datacenters/inside/locations/?hl=de
            </a>{' '}
            sehen Sie genau, wo die Google-Server stehen.
          </p>
          <p>
            Ihre Daten werden auf verschiedenen physischen Datenträgern
            verteilt. Dadurch sind die Daten schneller abrufbar und vor
            möglichen Manipulationen besser geschützt. Google hat auch
            entsprechende Notfallprogramme für Ihre Daten. Wenn es
            beispielsweise bei Google interne technische Probleme gibt und
            dadurch Server nicht mehr funktionieren, bleibt das Risiko einer
            Dienstunterbrechung und eines Datenverlusts dennoch gering.
          </p>
          <p>
            Je nach dem um welche Daten es sich handelt, speichert Google diese
            unterschiedlich lange. Manche Daten können Sie selbst löschen,
            andere werden von Google automatisch gelöscht oder anonymisiert. Es
            gibt aber auch Daten, die Google länger speichert, wenn dies aus
            juristischen oder geschäftlichen Gründen erforderlich ist.
          </p>
          <h3>
            <strong>
              Wie kann ich meinen Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Nach dem Datenschutzrecht der Europäischen Union haben Sie das
            Recht, Auskunft über Ihre Daten zu erhalten, sie zu aktualisieren,
            zu löschen oder einzuschränken. Es gibt einige Daten, die Sie
            jederzeit löschen können. Wenn Sie ein Google-Konto besitzen, können
            Sie dort Daten zu Ihrer Webaktivität löschen bzw. festlegen, dass
            sie nach einer bestimmten Zeit gelöscht werden sollen.
          </p>
          <p>
            In Ihrem Browser haben Sie zudem die Möglichkeit, Cookies zu
            deaktivieren, zu löschen oder nach Ihren Wünschen und Vorlieben zu
            verwalten. Hier finden Sie Anleitungen zu den wichtigsten Browsern:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Google ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework,
            wodurch der korrekte und sichere Datentransfer persönlicher Daten
            geregelt wird. Mehr Informationen dazu finden Sie auf
            <a href='https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;tid=311175631'>
              https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI
            </a>
            . Wir hoffen wir konnten Ihnen die wichtigsten Informationen rund um
            die Datenverarbeitung durch Google näherbringen. Wenn Sie mehr
            darüber erfahren wollen, empfehlen wir die umfangreiche
            Datenschutzerklärung von Google unter
            <a href='https://policies.google.com/privacy?hl=de'>
              https://policies.google.com/privacy?hl=de
            </a>
            .
          </p>
          <h2>
            <strong>Google Tag Manager Datenschutzerklärung</strong>
          </h2>
          <p>
            Für unsere Website verwenden wir den Google Tag Manager des
            Unternehmens Google Inc. Für den europäischen Raum ist das
            Unternehmen Google Ireland Limited (Gordon House, Barrow Street
            Dublin 4, Irland) für alle Google-Dienste verantwortlich. Dieser Tag
            Manager ist eines von vielen hilfreichen Marketing-Produkten von
            Google. Über den Google Tag Manager können wir Code-Abschnitte von
            diversen Trackingtools, die wir auf unserer Webseite verwenden,
            zentral einbauen und verwalten.
          </p>
          <p>
            In dieser Datenschutzerklärung wollen wir Ihnen genauer erklären was
            der Google Tag Manager macht, warum wir ihn verwenden und in welcher
            Form Daten verarbeitet werden.
          </p>
          <h3>
            <strong>Was ist der Google Tag Manager?</strong>
          </h3>
          <p>
            Der Google Tag Manager ist ein Organisationstool, mit dem wir
            Webseiten-Tags zentral und über eine Benutzeroberfläche einbinden
            und verwalten können. Als Tags bezeichnet man kleine
            Code-Abschnitte, die beispielsweise Ihre Aktivitäten auf unserer
            Webseite aufzeichnen (tracken). Dafür werden
            JavaScript-Code-Abschnitte in den Quelltext unserer Seite
            eingesetzt. Die Tags stammen oft von google-internen Produkten wie
            Google Ads oder Google Analytics, aber auch Tags von anderen
            Unternehmen können über den Manager eingebunden und verwaltet
            werden. Solche Tags übernehmen unterschiedliche Aufgaben. Sie können
            Browserdaten sammeln, Marketingtools mit Daten füttern, Buttons
            einbinden, Cookies setzen und auch Nutzer über mehrere Webseiten
            hinweg verfolgen.
          </p>
          <h3>
            <strong>
              Warum verwenden wir den Google Tag Manager für unserer Webseite?
            </strong>
          </h3>
          <p>
            Wie sagt man so schön: Organisation ist die halbe Miete! Und das
            betrifft natürlich auch die Pflege unserer Webseite. Um unsere
            Webseite für Sie und alle Menschen, die sich für unsere Produkte und
            Dienstleistungen interessieren, so gut wie möglich zu gestalten,
            brauchen wir diverse Trackingtools wie beispielsweise Google
            Analytics. Die erhobenen Daten dieser Tools zeigen uns, was Sie am
            meisten interessiert, wo wir unsere Leistungen verbessern können und
            welchen Menschen wir unsere Angebote noch zeigen sollten. Und damit
            dieses Tracking funktioniert, müssen wir entsprechende
            JavaScript-Codes in unsere Webseite einbinden. Grundsätzlich könnten
            wir jeden Code-Abschnitt der einzelnen Tracking-Tools separat in
            unseren Quelltext einbauen. Das erfordert allerdings relativ viel
            Zeit und man verliert leicht den Überblick. Darum nützen wir den
            Google Tag Manager. Wir können die nötigen Skripte einfach einbauen
            und von einem Ort aus verwalten. Zudem bietet der Google Tag Manager
            eine leicht zu bedienende Benutzeroberfläche und man benötigt keine
            Programmierkenntnisse. So schaffen wir es, Ordnung in unserem
            Tag-Dschungel zu halten.
          </p>
          <h3>
            <strong>
              Welche Daten werden vom Google Tag Manager gespeichert?
            </strong>
          </h3>
          <p>
            Der Tag Manager selbst ist eine Domain, die keine Cookies setzt und
            keine Daten speichert. Er fungiert als bloßer „Verwalter“ der
            implementierten Tags. Die Daten erfassen die einzelnen Tags der
            unterschiedlichen Web-Analysetools. Die Daten werden im Google Tag
            Manager quasi zu den einzelnen Tracking-Tools durchgeschleust und
            nicht gespeichert.
          </p>
          <p>
            Ganz anders sieht das allerdings mit den eingebundenen Tags der
            verschiedenen Web-Analysetools, wie zum Beispiel Google Analytics,
            aus. Je nach Analysetool werden meist mit Hilfe von Cookies
            verschiedene Daten über Ihr Webverhalten gesammelt, gespeichert und
            verarbeitet. Dafür lesen Sie bitte unsere Datenschutztexte zu den
            einzelnen Analyse- und Trackingtools, die wir auf unserer Webseite
            verwenden.
          </p>
          <p>
            In den Kontoeinstellungen des Tag Managers haben wir Google erlaubt,
            dass Google anonymisierte Daten von uns erhält. Dabei handelt es
            sich aber nur um die Verwendung und Nutzung unseres Tag Managers und
            nicht um Ihre Daten, die über die Code-Abschnitte gespeichert
            werden. Wir ermöglichen Google und anderen, ausgewählte Daten in
            anonymisierter Form zu erhalten. Wir stimmen somit der anonymen
            Weitergabe unseren Website-Daten zu. Welche zusammengefassten und
            anonymen Daten genau weitergeleitet werden, konnten wir – trotz
            langer Recherche – nicht in Erfahrung bringen. Auf jeden Fall löscht
            Google dabei alle Infos, die unsere Webseite identifizieren könnten.
            Google fasst die Daten mit Hunderten anderen anonymen
            Webseiten-Daten zusammen und erstellt, im Rahmen von
            Benchmarking-Maßnahmen, Usertrends. Bei Benchmarking werden eigene
            Ergebnisse mit jenen der Mitbewerber verglichen. Auf Basis der
            erhobenen Informationen können Prozesse optimiert werden.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Wenn Google Daten speichert, dann werden diese Daten auf den eigenen
            Google-Servern gespeichert. Die Server sind auf der ganzen Welt
            verteilt. Die meisten befinden sich in Amerika. Unter
            <a href='https://www.google.com/about/datacenters/inside/locations/?hl=de'>
              https://www.google.com/about/datacenters/inside/locations/?hl=de
            </a>{' '}
            können Sie genau nachlesen, wo sich die Google-Server befinden.
          </p>
          <p>
            Wie lange die einzelnen Tracking-Tools Daten von Ihnen speichern,
            entnehmen Sie unseren individuellen Datenschutztexten zu den
            einzelnen Tools.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Der Google Tag Manager selbst setzt keine Cookies, sondern verwaltet
            Tags verschiedener Tracking-Webseiten. In unseren Datenschutztexten
            zu den einzelnen Tracking-Tools, finden Sie detaillierte
            Informationen wie Sie Ihre Daten löschen bzw. verwalten können.
          </p>
          <p>
            Google ist aktiver Teilnehmer beim EU-U.S. Privacy Shield Framework,
            wodurch der korrekte und sichere Datentransfer persönlicher Daten
            geregelt wird. Mehr Informationen dazu finden Sie auf
            <a href='https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI'>
              https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;tid=311175631
            </a>
            . Wenn Sie mehr über den Google Tag Manager erfahren wollen,
            empfehlen wir Ihnen die FAQs unter
            <a href='https://www.google.com/intl/de/tagmanager/faq.html'>
              https://www.google.com/intl/de/tagmanager/faq.html
            </a>
            .
          </p>
          <h2>
            <strong>Amazon-Partnerprogramm Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf unserer Website das Amazon-Partnerprogramm des
            Unternehmens Amazon.com, Inc. Die verantwortlichen Stellen im Sinne
            der Datenschutzerklärung sind die Amazon Europe Core S.à.r.l., die
            Amazon EU S.à.r.l, die Amazon Services Europe S.à.r.l. und die
            Amazon Media EU S.à.r.l., alle vier ansässig 5, Rue Plaetis, L-2338
            Luxemburg sowie Amazon Instant Video Germany GmbH, Domagkstr. 28,
            80807 München. Als Datenverarbeiter wird die Amazon Deutschland
            Services GmbH, Marcel-Breuer-Str. 12, 80807 München, tätig. Durch
            die Verwendung dieses Amazon-Partnerprogramms können Daten von Ihnen
            an Amazon übertragen, gespeichert und verarbeitet werden.
          </p>
          <p>
            In dieser Datenschutzerklärung informieren wir Sie um welche Daten
            es sich handelt, warum wir das Programm verwenden und wie Sie die
            Datenübertragung verwalten bzw. unterbinden können.
          </p>
          <h3>
            <strong>Was ist das Amazon-Partnerprogramm?</strong>
          </h3>
          <p>
            Das Amazon-Partnerprogramm ist ein Affiliate-Marketing-Programm des
            Online-Versandunternehmens
            <a href='https://www.amazon.de/ref=as_li_ss_tl?site-redirect=at&amp;linkCode=ll2&amp;tag=thetraffic-21&amp;linkId=16a65fb03b8cb39206283c5345d87944&amp;language=de_DE&amp;tid=311175631'>
              Amazon.de
            </a>
            . Wie jedes Affiliate-Programm basiert auch das
            Amazon-Partnerprogramm auf dem Prinzip der Vermittlungsprovision.
            Amazon bzw. wir platzieren auf unserer Website Werbung oder
            Partnerlinks und wenn Sie darauf klicken und ein Produkt über Amazon
            kaufen, erhalten wir eine Werbekostenerstattung (Provision).
          </p>
          <h3>
            <strong>
              Warum verwenden wir das Amazon-Partnerprogramm auf unserer
              Webseite?
            </strong>
          </h3>
          <p>
            Unser Ziel ist es Ihnen eine angenehme Zeit mit vielen hilfreichen
            Inhalten zu liefern. Dafür stecken wir sehr viel Arbeit und Energie
            in die Entwicklung unserer Website. Mit Hilfe des
            Amazon-Partnerprogramms haben wir die Möglichkeit, für unsere Arbeit
            auch ein bisschen entlohnt zu werden. Jeder Partnerlink zu Amazon
            hat selbstverständlich immer mit unserem Thema zu tun und zeigt
            Angebote, die Sie interessieren könnten.
          </p>
          <h3>
            <strong>
              Welche Daten werden durch das Amazon-Partnerprogramm gespeichert?
            </strong>
          </h3>
          <p>
            Sobald Sie mit den Produkten und Dienstleistungen von Amazon
            interagieren, erhebt Amazon Daten von Ihnen. Amazon unterscheidet
            zwischen Informationen, die Sie aktiv dem Unternehmen geben und
            Informationen, die automatisch gesammelt und gespeichert werden. Zu
            den “aktiven Informationen” zählen zum Beispiel Name,
            E-Mail-Adresse, Telefonnummer, Alter, Zahlungsinformationen oder
            Standortinformationen. Sogenannte „automatische Informationen“
            werden in erster Linie über Cookies gespeichert. Dazu zählen
            Informationen zum Userverhalten, IP-Adresse, Gerätinformationen
            (Browsertyp, Standort, Betriebssysteme) oder die URL. Amazon
            speichert weiters auch den Clickstream. Damit ist der Weg
            (Reihenfolge der Seiten) gemeint, den Sie als User zurücklegen, um
            zu einem Produkt zu kommen. Auch um die Herkunft einer Bestellung
            nachvollziehen zu können, speichert Amazon Cookies in Ihrem Browser.
            So erkennt das Unternehmen, dass Sie über unsere Website eine
            Amazon-Werbeanzeige oder einen Partnerlink angeklickt haben.
          </p>
          <p>
            Wenn Sie ein Amazon-Konto haben und angemeldet sind, während Sie auf
            unserer Webseite surfen, können die erhobenen Daten Ihrem Account
            zugewiesen werden. Das verhindern Sie, indem Sie sich bei Amazon
            abmelden, bevor Sie auf unserer Website surfen.
          </p>
          <p>
            Hier zeigen wir Ihnen beispielhafte Cookies, die in Ihrem Browser
            gesetzt werden, wenn Sie auf unserer Website auf einen Amazon-Link
            kicken.
          </p>
          <p>
            <strong>Name</strong>: uid
          </p>
          <p>
            <strong>Wert: </strong>3230928052675285215311175631-9
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie speichert eine
            eindeutige User-ID und sammelt Informationen über Ihre
            Websiteaktivität.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Monaten
          </p>
          <p>
            <strong>Name</strong>: ad-id
          </p>
          <p>
            <strong>Wert: </strong>AyDaInRV1k-Lk59xSnp7h5o
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie wird von
            amazon-adsystem.com zur Verfügung gestellt und dient dem Unternehmen
            für verschiedene Werbezwecke.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 8 Monaten
          </p>
          <p>
            <strong>Name</strong>: uuid2
          </p>
          <p>
            <strong>Wert: </strong>8965834524520213028311175631-2
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie ermöglicht gezielte
            und interessensbezogene Werbung über die AppNexus-Plattform. Das
            Cookie sammelt und speichert über die IP-Adresse beispielsweise
            anonyme Daten darüber, welche Werbung Sie angeklickt haben und
            welche Seiten Sie aufgerufen haben.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 3 Monaten
          </p>
          <p>
            <strong>Name</strong>: session-id
          </p>
          <p>
            <strong>Wert: </strong>262-0272718-2582202311175631-1
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie speichert eine
            eindeutige User-ID, die der Server Ihnen für die Dauer eines
            Websitebesuchs (Session) zuweist. Besuchen Sie dieselbe Seite
            wieder, werden die darin gespeichert Information wieder abgerufen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 15 Jahren
          </p>
          <p>
            <strong>Name</strong>: APID
          </p>
          <p>
            <strong>Wert: </strong>UP9801199c-4bee-11ea-931d-02e8e13f0574
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie speichert
            Informationen darüber, wie Sie eine Website nutzen und welche
            Werbung Sie vor dem Websitebesuch angesehen haben.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach einem Jahr
          </p>
          <p>
            <strong>Name</strong>: session-id-time
          </p>
          <p>
            <strong>Wert: </strong>
            tb:s-STNY7ZS65H5335FZEVPE|1581329862486&amp;t:1581329864300&amp;adb:adblk_no
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Dieses Cookie erfasst die Zeit,
            die Sie mit einer eindeutigen Cookie-ID auf einer Webseite
            verbringen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 2 Jahren
          </p>
          <p>
            <strong>Name</strong>: csm-hit
          </p>
          <p>
            <strong>Wert: </strong>2082754801l
          </p>
          <p>
            <strong>Verwendungszweck: </strong>Wir könnten über dieses Cookie
            keine genauen Informationen in Erfahrung bringen.
          </p>
          <p>
            <strong>Ablaufdatum: </strong> nach 15 Jahren
          </p>
          <p>
            <strong>Anmerkung: </strong>Bitte beachten Sie, dass diese Liste
            lediglich Cookie-Beispiele zeigt und keinen Anspruch auf
            Vollständigkeit erheben kann.
          </p>
          <p>
            Amazon nutzt diese erhaltenen Informationen, um Werbeanzeigen
            genauer an die Interessen der User abzustimmen.
          </p>
          <h3>
            <strong>Wie lange und wo werden die Daten gespeichert?</strong>
          </h3>
          <p>
            Persönliche Daten werden von Amazon so lange gespeichert, wie es für
            die geschäftlichen Dienste von Amazon erforderlich ist oder aus
            rechtlichen Gründen notwendig ist. Da das Unternehmen Amazon seinen
            Hauptsitz in den USA hat, werden die gesammelten Daten auch auf
            amerikanischen Servern gespeichert.
          </p>
          <h3>
            <strong>
              Wie kann ich meine Daten löschen bzw. die Datenspeicherung
              verhindern?
            </strong>
          </h3>
          <p>
            Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten
            zuzugreifen und sie auch zu löschen. Wenn Sie einen Amazon-Account
            besitzen, können Sie in Ihrem Account viele der erhobenen Daten
            verwalten oder löschen.
          </p>
          <p>
            Eine weitere Option, die Datenverarbeitung und -speicherung durch
            Amazon nach Ihren Vorlieben zu verwalten, bietet Ihr Browser. Dort
            können Sie Cookies verwalten, deaktivieren oder löschen. Dies
            funktioniert bei jedem Browser ein bisschen anders. Hier finden Sie
            die Anleitungen zu den gängigsten Browsern:
          </p>
          <p>
            <a href='https://support.google.com/chrome/answer/95647?tid=311175631'>
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a href='https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311175631'>
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a href='https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311175631'>
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311175631'>
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a href='https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311175631'>
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Amazon ist aktiver Teilnehmer des EU-U.S. Privacy Shield Frameworks,
            wodurch der korrekte Datentransfer persönlicher Daten zwischen den
            USA und der EU geregelt wird. Mehr Informationen dazu finden Sie auf
            <a href='https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4&amp;tid=311175631'>
              https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4
            </a>
            . Wir hoffen wir haben Ihnen die wichtigsten Informationen über die
            Datenübertragung durch die Verwendung von dem Amazon-Partnerprogramm
            nähergebracht. Mehr Informationen finden Sie unter
            <a href='https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010'>
              https://www.amazon.de/gp/help/customer/display.html?nodeId=201909010
            </a>
            .
          </p>
          <h2>
            <strong>Pinterest Datenschutzerklärung</strong>
          </h2>
          <p>
            Wir verwenden auf unserer Seite Buttons und Widgets des Social Media
            Netzwerks Pinterest, der Firma Pinterest Inc.,808 Brannan Street,
            San Francisco, CA 94103, USA.
          </p>
          <p>
            Durch den Aufruf von Seiten die solche Funktionen nutzen werden
            Daten (IP-Adresse, Browserdaten, Datum und Zeitpunkt, Cookies) an
            Pinterest übermittelt, gespeichert und ausgewertet.
          </p>
          <p>
            Die Datenschutzrichtlinien, welche Informationen Pinterest sammelt
            und wie sie diese verwenden finden Sie auf
            <a href='https://policy.pinterest.com/de/privacy-policy'>
              https://policy.pinterest.com/de/privacy-policy
            </a>
            .
          </p>
          <p>
            Quelle: Erstellt mit dem{' '}
            <a href='https://www.adsimple.de/datenschutz-generator/'>
              Datenschutz Generator
            </a>{' '}
            von AdSimple in Kooperation mit
            <a href='https://www.hashtagmann.de'>hashtagmann.de</a>
          </p>

          <p></p>

          <h3>Schlussbestimmungen</h3>
          <p>
            Als Rechtsgrundlage wird ausschließlich deutsches Recht gewählt, das
            UN-Kaufrecht findet keine Anwendung. Der User kann Rechte und
            Pflichten aus diesem Vertrag nicht übertragen. Ändert der Anbieter
            die AGB, kann der User innerhalb eines Monats nach Zugang der
            Änderungsmitteilung widersprechen. Widerspricht der User fristgemäß,
            so ist Media Juice berechtigt, das Vertragsverhältnis
            außerordentlich und ohne Einhaltung einer Kündigungsfrist zu
            kündigen. Auf das Widerspruchsrecht und darauf, dass die Änderung
            der AGB mit Beginn des auf den Fristablauf folgenden Monats gültig
            wird, wenn der User sich nicht fristgerecht anderweitig erklärt,
            wird ausdrücklich hingewiesen.
          </p>
        </TextContainer>
      </LegalPage>
    </Layout>
  </>
)

export default LegalPageTemplate
